export default {
    "id": "ID",
    "dashboard": "Dashibodi",
    "warning": "Onyo",
    "users": "Watumiaji",
    "farms": "Mashamba",
    "animals": "Wanyama",
    "action": "Kitendo",
    "actionList": "Orodha ya Vitendo",
    "drugInventory": "Malipo ya Dawa",
    "inseminatorStatistics": "Takwimu za Inseminator",
    "organizationNTR": "Shirika la NTR",
    "genotypePerformance": "Utendaji wa Genotype",
    "semenAutomation": "Kujiendesha kwa shahawa",
    "activityLogs": "Kumbukumbu ya Shughuli",
    "username": "Jina la mtumiaji",
    "title": "Kichwa",
    "deactivated": "Imezimwa",
    "name": "Jina",
    "email": "Barua pepe",
    "emailAddress": "Barua pepe",
    "mobileNum": "Namba ya simu ya mkononi",
    "emailOrMobile": "Barua pepe/Simu",
    "role": "Jukumu",
    "roles": "Majukumu",
    "department": "Idara",
    "status": "Hali",
    "pages": "Kurasa",
    "departments": "Idara",
    "password": "Nenosiri",
    "cancel": "Ghairi",
    "submit": "Wasilisha",
    "error": "kosa",
    "success": "mafanikio",
    "Browse": "Vinjari",
    "orDropYourFileCsvXlsXlsxHere": "au dondosha faili yako (CSV, XLS, XLSx) hapa",
    "search": "Tafuta",
    "apply": "Omba",
    "select": "Chagua",
    "previous": "Iliyotangulia",
    "mandatory": "Lazima",
    "dropYourFileHere": "au dondosha faili yako (CSV, XLS, XLSx, PDF,Docx,PNG,JPEG) hapa",
    "restoreDefault": "Rejesha Chaguomsingi",
    "pending": "Inasubiri",
    "completed": "Imekamilika",
    "remove": "Ondoa",
    "update": "Sasisha",
    "removeFile": "Ondoa Faili",
    "uploadFile": "Pakia Faili",
    "pleaseChoosePreferedLanguage": "Tafadhali chagua lugha unayopendelea",
    "edit": "Hariri",
    "activate": "Amilisha",
    "deactivate": "Zima",
    "recievedOrders": "Maagizo Yaliyopokelewa",
    "chartRepresentation": "Uwakilishi wa Chati",
    "nameIsRequired": "Jina linahitajika",
    "export": "Hamisha",
    "noFilesAvailable": "HAKUNA FAILI ZINAZOPATIKANA",
    "selectDepartmentToshowRoles": "Chagua idara ya kuonyesha majukumu",
    "selectDepartmentWithActiveRoles": "Chagua idara yenye majukumu amilifu",
    "nameCanContainOnlyAlphabets": "Jina linaweza kuwa na alfabeti pekee",
    "nameMustBeLessThan15Chars": "Jina lazima liwe chini ya herufi 30",
    "emailRequired": "Barua pepe inahitajika",
    "invalidEmailFormat": "Umbizo la Barua Pepe si Sahihi",
    "mobNumReq": "Nambari ya simu inahitajika",
    "invalidMobFormat": "Umbizo batili la nambari ya simu.",
    "passwordRequired": "Nenosiri linahitajika",
    "departmentReq": "Idara inahitajika",
    "roleReq": "Jukumu linahitajika",
    "unableToUpdate": "Imeshindwa kusasisha",
    "orignalName": "Jina la asili",
    "uploadedDate": "Tarehe Iliyopakiwa",
    "fileName": "Jina la faili",
    "importNum": "Nambari ya Kuingiza",
    "languagePreferences": "Upendeleo wa Lugha",
    "pleaseTryAgainAfterSometime": "Tafadhali jaribu baada ya muda fulani",
    "noChanges": "Hakuna Mabadiliko",
    "nothingchanged": "Hakuna Iliyobadilika",
    "pleaseChooseAnImageFile": "Tafadhali chagua faili ya picha",
    "fileIsTooBigSelectUnder1MB": "Faili yako ni kubwa mno! ",
    "phoneShouldHave10Chars": "Simu inapaswa kuwa na herufi 10",
    "onlyCSVAllowed": "Faili ya CSV pekee ndiyo inaruhusiwa",
    "loadingPleaseWait": "Inapakia... Tafadhali subiri",
    "manager": "Meneja",
    "administrator": "msimamizi",
    "Comingsoon": "Inakuja Hivi Karibuni",
    "totalAnimals": "Jumla ya Wanyama",
    "receivedOrders": "Agizo Zilizopokelewa",
    "drugs": "Madawa",
    "detailedAnalysis": "Uchambuzi wa Kina",
    "barGraphRepOfActiveUsersAndDeactivateUsers": "Uwakilishi wa Grafu ya Baa ya Watumiaji Wanaotumika na Watumiaji Waliozimia",
    "barGraphRepOfRegAnimalsVsFarm": "Uwakilishi wa Grafu ya Baa ya Wanyama Waliosajiliwa Vs Shamba",
    "roleNumber": "Nambari ya Wajibu",
    "roleName": "Jina la jukumu",
    "active": "Inayotumika",
    "inactive": "Haitumiki",
    "admin": "Msimamizi",
    "addRole": "Ongeza Jukumu",
    "addRoles": "Ongeza Majukumu",
    "permissions": "Ruhusa",
    "sr": "Sr.",
    "moduleName": "Jina la Moduli",
    "view": "Tazama",
    "deptNo": "Idara Na.",
    "selectByCategory": "Chagua Kwa kategoria",
    "weeklyAnalytics": "Uchanganuzi wa Kila Wiki",
    "pregnancy": "Mimba",
    "analytics": "Uchanganuzi",
    "calendar": "Kalenda",
    "productName": "Jina la bidhaa",
    "volumeSold": "Kiasi Kinauzwa",
    "recordPoints": "Rekodi Pointi",
    "inStock": "Katika Hisa",
    "revenue": "Mapato",
    "stockStatus": "Hali ya Hisa",
    "barChart": "Chati ya Baa",
    "lineChart": "Chati ya mstari",
    "indexReturns": "Index Returns",
    "chart": "Chati",
    "time": "wakati",
    "production": "Uzalishaji",
    "customization": "Kubinafsisha",
    "recordsPerPage": "Rekodi kwa kila Ukurasa",
    "noDataAvailable": "Hakuna Data Inayopatikana",
    "reporting": "Kuripoti",
    "optional": "Hiari",
    "note": "Kumbuka",
    "notes": "Vidokezo",
    "date": "Tarehe",
    "kG": "KILO",
    "weight": "uzito",
    "type": "Aina",
    "lessthan3Month": "<Miezi 3",
    "lessthan6Month": "<Miezi 6",
    "lessthan7Month": "<Miezi 7",
    "lastWeek": "Wiki iliyopita",
    "thisWeek": "Wiki hii",
    "lessthanOneYear": "<Miaka 1",
    "lessthanTwoYear": "<Miaka 2",
    "lessthanThreeYear": "<Miaka 3",
    "lessthanFourYear": "<Miaka 4",
    "yes": "Ndiyo",
    "no": "Hapana",
    "of": "ya",
    "notSpecified": "Haijabainishwa",
    "days": "siku",
    "day": "siku",
    "aDay": "siku",
    "years": "miaka",
    "year": "mwaka",
    "unit": "kitengo",
    "units": "Vitengo",
    "to": "kwa",
    "profile": "Wasifu",
    "logOut": "Ondoka",
    "Unit": "Kitengo",
    "otherSettings": "Mipangilio Mingine",
    "somethingWentWrong": "kuna kitu kilienda vibaya.",
    "toDo": "Kufanya",
    "loadingData": "Inapakia Data...",
    "taskNumber": "Nambari ya Kazi",
    "taskName": "Jina la Kazi",
    "startDate": "Tarehe ya Kuanza",
    "dueDate": "Tarehe ya kukamilisha",
    "reason": "Sababu",
    "quantity": "Kiasi",
    "cost": "Gharama",
    "noRecordFound": "Hakuna Rekodi Imepatikana",
    "dailyUpdates": "Sasisho za Kila Siku",
    "weeklyUpdates": "Sasisho za Wiki",
    "moduleAccessed": "Moduli Imefikiwa",
    "typesOfAccess": "Aina za Ufikiaji",
    "userId": "Kitambulisho cha Mtumiaji",
    "lastLogin": "Mwisho wa Kuingia",
    "terminalID": "Kitambulisho cha terminal",
    "geographicalAccessPoint": "Sehemu ya Kufikia Kijiografia",
    "iPAddress": "Anwani ya IP",
    "fileAccessed": "Faili Imefikiwa",
    "functionAccessed": "Kazi Imefikiwa",
    "webPageURL": "URL ya Ukurasa wa Wavuti",
    "accessType": "Aina ya Ufikiaji",
    "unsuccessfulLoginAttempts": "Jaribio la Kuingia Bila Mafanikio",
    "customerAddress": "Anwani ya Mteja",
    "orderdate": "Tarehe ya Agizo",
    "postageDate": "Tarehe ya posta",
    "postID": "Kitambulisho cha posta",
    "packingTechnician": "Ufungaji Fundi",
    "packingTechnicia": "Ufungaji Technicia",
    "packEdit": "Pakiti Hariri",
    "batchNumber": "Nambari ya Kundi",
    "collectionTechnician": "Mkusanyiko wa Fundi",
    "collectionTechnicia": "Mbinu ya Ukusanyaji",
    "preparationTechnicia": "Mbinu ya Maandalizi",
    "preparationTechnician": "Fundi Maandalizi",
    "approvedManually": "Imeidhinishwa Manukuu",
    "researcher": "Mtafiti",
    "dateOfApproval": "Tarehe ya Kuidhinishwa",
    "approvalEdit": "Idhini Hariri",
    "searchByAllExceptDate": "Tafuta Kwa Wote isipokuwa Tarehe",
    "approval": "Ruhusa",
    "collection": "Mkusanyiko",
    "postage": "Posta",
    "pack": "Pakiti",
    "straws": "Mirija",
    "createdAt": "Imeundwa Katika",
    "sireID": "Kitambulisho cha Sire",
    "economicIndexValue": "Thamani ya Kielezo cha Uchumi",
    "latestCollectionDate": "Tarehe ya Hivi Punde ya Mkusanyiko",
    "locationId": "Kitambulisho cha Mahali",
    "lastUpdated": "Ilisasishwa Mwisho",
    "print": "Chapisha",
    "save": "Hifadhi",
    "tax": "Kodi",
    "phoneNo": "Namba ya simu",
    "exportAsPDF": "Hamisha kama PDF",
    "statusUpdated": "Hali Imesasishwa",
    "statusNotUpdated": "Hali Haijasasishwa",
    "inProgress": "Inaendelea",
    "assignedTo": "Imekabidhiwa Kwa",
    "taskId": "Kitambulisho cha kazi",
    "createdDate": "Tarehe iliyoundwa",
    "numberOfAnimals": "Idadi ya Wanyama",
    "healthRecordSubmittedSuccess": "Rekodi ya Afya Imewasilishwa kwa ufanisi",
    "healthRecordSubmitted": "Rekodi ya Afya Imewasilishwa.",
    "InseminationRecordSubmittedSuccesful": "Rekodi ya Kuzaa Imewasilishwa kwa mafanikio",
    "inseminationRecordSubmitted": "Rekodi ya Upandaji mbegu Imewasilishwa.",
    "actionListDailyTask": "Orodha ya Vitendo - Jukumu la Kila Siku",
    "sinceLastYear": "Tangu Mwaka Jana",
    "sinceLastQuarter": "Tangu Robo Iliyopita",
    "sinceLastMonth": "Tangu Mwezi uliopita",
    "sinceLastWeek": "Tangu Wiki Iliyopita",
    "drugWithdrawPeriod": "Kipindi cha Kuondoa Dawa",
    "diagnosisName": "Jina la Utambuzi",
    "animalWithNoGenetype": "Mnyama huyu hana data yoyote ya Genotype iliyosajiliwa. ",
    "nameOfPreviousOwner": "Jina la Mmiliki Aliyetangulia",
    "avatarSize": "Ukubwa wa avatar unapaswa kuwa chini ya MB 1!",
    "testDestination": "Mtihani Lengwa",
    "animalNotAdded": "Mnyama Hajaongezwa",
    "registerationSuccessful": "Usajili Umefaulu",
    "backToAnimalList": "Rudi kwenye Orodha ya Wanyama",
    "addAnotherAnimal": "Ongeza Mnyama mwingine",
    "animalDetailsUpdated": "Maelezo ya wanyama yamesasishwa",
    "animalUpdatedSuccessfully": "Mnyama Imesasishwa Kwa Mafanikio",
    "animalNotUpdated": "Mnyama Haijasasishwa",
    "notMember": "Si mwanachama?",
    "requestAccess": "Omba ufikiaji",
    "typePassword": "Tafadhali chapa nenosiri.",
    "minChars": "angalau herufi 6",
    "typeConfirmPassword": "chapa thibitisha nenosiri",
    "passConfig": "Uthibitishaji wa nenosiri haulingani.",
    "invalidEmailMobile": "Umbizo batili la barua pepe/simu",
    "passwordNotEmpty": "Nenosiri haliwezi kuwa tupu",
    "passwordLength": "Urefu wa nenosiri hauwezi kuwa chini ya herufi 8",
    "cityVillage": "Mji/Kijiji",
    "districtRegion": "Wilaya/Mkoa",
    "alreadyHaveAnAccount": "Je, una akaunti tayari?",
    "genetypeUpdated": "GenoType Imesasishwa",
    "genetypeNotUpdated": "GenoType Haijasasishwa",
    "sellTrade": "Uza/Biashara",
    "milkingDevon": "Hisa ya Kukamua ya Devon Inauzwa",
    "detailedDescription": "Maelezo ya Kina",
    "longPara": "Marekani Kukamua Devon Fahali ng'ombe na ng'ombe. ",
    "contactSeller": "Wasiliana na Muuzaji",
    "enterListingTitle": "Ingiza Kichwa cha Kuorodhesha",
    "livestocktype": "Aina ya Mifugo",
    "uploadImage": "Pakia Picha",
    "mobilePhone": "Nambari ya Simu ya Mkononi",
    "myLivestock": "Mifugo Yangu",
    "livestockObservations": "Uchunguzi wa Mifugo",
    "selectFromRegisteredAnimals": "Chagua Kutoka kwa Orodha ya Wanyama Waliosajiliwa",
    "selectOption": "Chagua Chaguo",
    "selectTypeObservation": "Chagua Aina ya Uchunguzi",
    "attachVeteinaryDocument": "Ambatisha Hati ya Mifugo",
    "addsensorReading": "Ongeza Usomaji wa Kihisi",
    "myDocument": "Nyaraka Zangu",
    "enterAKeyword": "Weka Neno Muhimu",
    "documentType": "Aina ya Hati",
    "registerEditLivestock": "Sajili/Hariri Mifugo",
    "editLivestockProfile": "Hariri Wasifu wa Mifugo",
    "copy": "Nakili",
    "dateOfRegister": "Tarehe ya Usajili",
    "livestockType": "Aina ya Mifugo",
    "registerNewLivestock": "Kusajili Mifugo Mpya",
    "enterUniqueTag": "Ingiza Lebo ya Kipekee",
    "color": "Rangi",
    "gender": "Jinsia",
    "male": "Mwanaume",
    "female": "Mwanamke",
    "damm": "Bwawa",
    "siree": "Bwana",
    "dateOfSaleAuction": "Tarehe ya Mauzo/Mauzo ya Mnada",
    "auctionRecord": "Rekodi ya Mnada ya Orodha ya Waliokufa",
    "distinguishingFeatures": "Vipengele vya Kutofautisha",
    "keywordListing": "Nenomsingi au Kitambulisho cha Orodha",
    "adType": "Aina ya Tangazo",
    "activeListingFund": "Orodha 1 Inayotumika Imepatikana",
    "setupSensors": "Sanidi Sensorer",
    "serialNumber": "Nambari ya Ufuatiliaji",
    "sensorLocation": "Mahali pa Kihisi",
    "sensorType": "Aina ya Sensor",
    "installationDate": "Tarehe ya Ufungaji",
    "ExpirationDate": "Tarehe ya kumalizika muda wake",
    "addGeo": "Ongeza Geolocation",
    "addMoreSensors": "Ongeza Vihisi Zaidi",
    "trackAndTrace": "Kufuatilia na Kufuatilia",
    "createNewShipment": "Unda Usafirishaji Mpya",
    "workflowReference": "Rejea ya mtiririko wa kazi",
    "invoiceDate": "Tarehe ya ankara",
    "trackShipment": "Fuatilia Usafirishaji",
    "totalShipments": "Jumla ya Usafirishaji",
    "activeShipment": "Usafirishaji Amilifu",
    "completedObjectives": "Malengo Yaliyokamilika",
    "processedPayments": "Malipo Yanayochakatwa",
    "pointOfDestination": "Mahali Unakoenda",
    "sellerInformation": "Taarifa za Muuzaji",
    "selectSellerConsignor": "Chagua Muuzaji/Mpokeaji",
    "pointOfOrigin": "Pointi ya Asili",
    "buyerInfo": "Taarifa za Mnunuzi",
    "selectBuyerConsignor": "Chagua Mnunuzi/Mpokeaji",
    "addSensorTriggers": "Ongeza Vichochezi vya Sensor",
    "processPayments": "Mchakato wa Malipo",
    "defineShippingContract": "Bainisha Mkataba wa Usafirishaji",
    "addDigitize": "Ongeza",
    "currentlyOnFarm": "Hivi sasa kwenye Shamba",
    "addSire": "Ongeza Bwana",
    "addApproval": "Ongeza Idhini",
    "addCollection": "Ongeza Mkusanyiko",
    "addStraws": "Ongeza Majani",
    "addPack": "Ongeza Kifurushi",
    "addPostage": "Ongeza Posta",
    "searchBySire": "Tafuta kwa Bwana",
    "anyDataChangeMightBeLost": "Mabadiliko yoyote ya data yanaweza kupotea",
    "wouldYouLikeToSaveOrWantToLeaveWithoutSaving": "Je, ungependa kuhifadhi au ungependa kuondoka bila kuhifadhi",
    "leave": "Ondoka",
    "stay": "Kaa",
    "animalFarm": "Shamba la Wanyama",
    "animalFarmH": "Shamba la Wanyama",
    "animalOrigin": "Asili ya Wanyama",
    "animalOriginH": "Asili ya Wanyama",
    "farmOfOrigin": "Shamba La Asili",
    "farmOfOriginH": "Shamba La Asili",
    "selectFarm": "Chagua Shamba",
    "searchFarm": "Tafuta Shamba",
    "confirmation": "Uthibitisho",
    "proceed": "Endelea",
    "ok": "sawa",
    "animal": {
      "tagH": "Lebo",
      "tagNumberH": "Nambari ya Tag: Unaweza kuongeza rangi na nambari. ",
      "goveRegNoH": "Nambari iliyotolewa wakati wa kujiandikisha na shirika la serikali",
      "birthWeightH": "Uzito wa Kuzaliwa kwa Ndama",
      "birthEaseH": "Kuzaa kwa mifugo ni jambo la asili lakini wakati mwingine kunaweza kuwa na matatizo ya uzazi ambapo bwawa linahitaji msaada kutoka kwa mkulima/mfugaji.",
      "birthFarmH": "Shamba la asili ya wanyama / kuzaliwa.",
      "surrogateDamH": "Kitambulisho cha ng'ombe jike ambamo yai lililorutubishwa kutoka kwa mtoaji dume na jike wafadhili hupandikizwa kwa ajili ya maendeleo yake zaidi.",
      "ownerH": "Hili ndilo jina la mmiliki wa mnyama.",
      "damH": "Kitambulisho cha mzazi wa kike/mama wa mnyama.",
      "sireH": "Kitambulisho cha Mwanaume mzazi/baba wa mnyama.",
      "breedH": "Uzazi ni kundi mahususi la wanyama wa kufugwa walio na mwonekano wa aina moja (phenotipu), tabia ya kufanana, na/au sifa zingine zinazoitofautisha na viumbe vingine vya spishi sawa.",
      "conceptionMethodH": "Jinsi mnyama alivyotungwa.",
      "genderH": "Jinsia ya mnyama.",
      "dobH": "Tarehe ya kuzaliwa kwa mnyama.",
      "operatorH": "Jina la mtu anayejaza maelezo ya mnyama huyu.",
      "removalFarmH": "Shamba la Kuondolewa kwa Wanyama ",
      "dateOfRemovalH": "Tarehe ya kuondolewa kwa wanyama",
      "destinationOfRemoval": "Mahali pa kufikia mnyama aliyeondolewa",
      "reasonOfRemovalH": "Sababu ya kuondolewa kwa wanyama",
      "trackingNumberH": "Nambari iliyotolewa kwa mnyama wakati mnyama ameondolewa",
      "brandH": "Brand-Alama ya kudumu ambayo ilichomwa kwenye ng'ombe.",
      "tattoH": "Tattoo juu ya mnyama.",
      "hornStatusH": "Ikiwa mnyama amekatwa pembe.",
      "animalOriginH": "Nchi ya asili ya wanyama.",
      "previousOwnerH": "Jina la mmiliki wa awali wa mnyama ikiwa ni mtu mzima.",
      "twinH": "Shamba hili linasema iwapo mnyama ana pacha au la.",
      "regBreedAssoNoH": "Usajili na Vyama/Jumuiya za mifugo.",
      "breedAssoNameH": "Jina la Vyama/Jumuiya ambapo mnyama huyo alisajiliwa",
      "breederH": "Hili ndilo jina la shirika ambalo lilitoa mnyama.",
      "breeder": "Mfugaji",
      "noteH": "Vidokezo muhimu kuhusu mnyama.",
      "accuracyWeight_for_field": "Uzito wa Usahihi",
      "conception": "Dhana",
      "addAnAnimal": "Ongeza Mnyama",
      "addAnimal": "Ongeza Mnyama",
      "registerAnAnimal": "Kusajili Mnyama",
      "uploadAnAnimal": "Pakia Mnyama",
      "animalRegistration": "Usajili wa Wanyama",
      "animalDetails": "Maelezo ya Wanyama",
      "tag": "Lebo",
      "tagNumber": "Nambari ya Tag",
      "govtRegNumber": "Serikali. ",
      "birthWeight": "Uzito wa Kuzaliwa (lbs)",
      "birthEase": "Urahisi wa Kuzaliwa",
      "birthFarm": "Shamba la Kuzaliwa",
      "surrogateDam": "Bwawa la Surrogate",
      "owner": "Mmiliki",
      "ownershipType": "Aina ya Umiliki",
      "animalDiseaseRecord": "Rekodi ya Ugonjwa wa Wanyama",
      "govtReg": "Serikali. ",
      "regDate": "Tarehe ya Reg",
      "dam": "Bwawa",
      "sire": "Bwana",
      "heifer": "Ng'ombe",
      "steer": "Badili",
      "calf": "Ndama",
      "farmHerd": "Shamba/Kufuga",
      "femaleCalf": "Ndama wa Kike",
      "maleCalf": "Ndama wa kiume",
      "newCalves": "Ndama Mpya",
      "breed": "Kuzaliana",
      "conceptionMethod": "Njia ya Kutunga",
      "gender": "Jinsia",
      "dateOfBirth": "Tarehe ya kuzaliwa",
      "operator": "Opereta",
      "animalRemovedFarm": "Shamba la Kuondolewa kwa Wanyama",
      "dateOfAnimalRemoval": "Tarehe ya Kuondolewa kwa Wanyama",
      "destinationOfRemovedAnimal": "Marudio ya Mnyama Aliyeondolewa",
      "reasonOfRemoval": "Sababu ya Kuondolewa",
      "optionalAnimalInformation": "Habari za Wanyama za Hiari",
      "animalPicture": "Picha ya Mnyama",
      "trackingNumber": "Nambari ya Ufuatiliaji",
      "brand": "Chapa",
      "tatto": "Tatoo",
      "hornStatus": "Hali ya Pembe",
      "animalOrigin": "Asili ya Wanyama",
      "previosOwner": "Mmiliki wa awali",
      "twin": "Pacha",
      "InABreedAssociation": "Reg.",
      "nameOfBreedAssociations": "Jina la Vyama vya Wafugaji",
      "breedAssociations": "Mashirika ya Ufugaji",
      "breederSupplier": "Mfugaji (Msambazaji)",
      "importAnimal": "Ingiza Mnyama",
      "loadingAnimals": "Inapakia Wanyama... Tafadhali subiri",
      "totalRegAnimals": "Jumla ya Reg. ",
      "totalPregnantAnimals": "Jumla ya Wanyama Wajawazito",
      "pregnantAnimalHistory": "Historia ya Wanyama Wajawazito",
      "dailyAnimalPregnancyUpdates": "Sasisho za Mimba za Wanyama Kila Siku",
      "animalHistory": "Historia ya Wanyama",
      "dailyAnimalUpdates": "Kila Siku Wanyama Updates",
      "totalPregnant": "Mjamzito Jumla",
      "totalNewBorn": "Jumla Mpya Kuzaliwa",
      "searchByIDGOVRegTag": "Tafuta kwa Kitambulisho, Reg ya GOV na Tag",
      "noANIMALAVAILABLE": "HAKUNA MNYAMA ANAYEPATIKANA",
      "associationNumber": "Nambari ya Chama",
      "associationName": "Jina la Chama",
      "destinationName": "Jina Lengwa",
      "plastic": "Plastiki",
      "metal": "Chuma",
      "naturalMating": "Kuoana kwa asili",
      "artificialInsemination": "Uhimilishaji Bandia",
      "embryoTransfer": "Uhamisho wa kiinitete",
      "noAssistance": "Hakuna Msaada",
      "someAssistance": "Msaada fulani",
      "mechanicalAssistance": "Usaidizi wa Mitambo",
      "aCesareanSection": "Sehemu ya upasuaji",
      "abnormalDelivery": "Utoaji Usio wa Kawaida",
      "male": "Mwanaume",
      "female": "Mwanamke",
      "castrated": "Kuhasiwa",
      "sale": "Uuzaji",
      "slaughter": "Kuchinja",
      "death": "Kifo",
      "theft": "Wizi",
      "other": "Nyingine",
      "horned": "Mwenye pembe",
      "polled": "Imepiga kura",
      "dehorned": "Haina pembe",
      "details": "Maelezo",
      "performance": "Utendaji",
      "geneticWorth": "Thamani ya Kinasaba",
      "healthRecord": "Rekodi ya Afya",
      "genotypeData": "Data ya Genotype",
      "reminders": "Vikumbusho",
      "activityLog": "Kumbukumbu ya Shughuli",
      "activityLogDetails": "Maelezo ya Kumbukumbu ya Shughuli",
      "editAnimal": "Badilisha Mnyama",
      "familyInfo": "Taarifa za Familia",
      "breedInfo": "Maelezo ya Kuzaliana",
      "identification": "Utambulisho",
      "removalInfo": "Maelezo ya Kuondoa",
      "iDOfAnimalDam": "Kitambulisho cha bwawa la wanyama.",
      "iDOfAnimalSire": "Kitambulisho cha baba wa mnyama.",
      "iDOfDamEmbryoUsed": "Kitambulisho cha bwawa ambalo kiinitete kilitumika.",
      "animalHasATwinOrNot": "Ikiwa mnyama ana pacha au la.",
      "breedType": "Aina ya Kuzaliana",
      "breedOfTheAnimal": "Huu ni uzao wa mnyama.",
      "regBreedAssociations": "Usajili na Vyama/ Vyama vya kuzaliana.",
      "nameOfAssociationsSocieties": "Jina la Vyama/Jumuiya ambapo mnyama alisajiliwa.",
      "nameOfTheOrgSuppliedAnimal": "Hili ndilo jina la shirika ambalo lilitoa mnyama.",
      "countryOriginAnimal": "Nchi ya asili ya wanyama.",
      "birthFarmID": "Kitambulisho cha Shamba la Kuzaliwa",
      "farmIDAnimalBorn": "Kitambulisho cha shamba ambapo mnyama alizaliwa.",
      "currentOwner": "Mmiliki wa Sasa",
      "nameOfOwnerAnimal": "Hili ndilo jina la mmiliki wa mnyama.",
      "registrationDate": "Tarehe ya Usajili",
      "previousOwner": "Mmiliki wa awali",
      "nameOfOperator": "Jina la mwendeshaji",
      "dateAnimalRemoved": "Tarehe ya kuondolewa kwa mnyama.",
      "destinationPlaceRemovedAnimal": "Mahali pa kufikia mnyama aliyeondolewa",
      "namePersonFillAnimalInformation": "Jina la mtu anayejaza maelezo ya mnyama huyu.",
      "reasonOfAnimalRemoval": "Sababu ya kuondolewa kwa wanyama",
      "reasonWhyTheAnimalIsRemoved": "Sababu kwa nini mnyama huondolewa",
      "processingDate": "Tarehe ya usindikaji",
      "DateInformationFilledChanged": "Tarehe ambapo taarifa ya sasa ilijazwa au kubadilishwa.",
      "animalID": "Kitambulisho cha Mnyama",
      "UniqueIdAnimal": "Hii ni kitambulisho cha kipekee cha mnyama.",
      "plasticTagNumber": "Nambari ya Lebo ya Plastiki",
      "numberAnimalTag": "Idadi ya lebo ya Mnyama.",
      "rFTagNumber": "Nambari ya Lebo ya RF",
      "numberAnimalRFTag": "Idadi ya lebo ya RF ya wanyama.",
      "govtRegNumb": "Serikali. ",
      "govtRegistrationNumber": "Maelezo ya kitambulisho ambayo yanaweza kujumuisha jina na anwani ya mtu binafsi, wakala wa mtu binafsi kwa ajili ya huduma ya mchakato, eneo la shughuli itakayofanywa, na maelezo ya huduma ambayo mtu binafsi hutoa.",
      "numberAssignedAnimalIsRemoved": "Nambari ya ufuatiliaji ni mojawapo ya vitambulisho vya wanyama vinavyotumika kufuatilia shughuli za wanyama.",
      "dateOfAnimalRegistration": "Tarehe ya usajili wa wanyama",
      "stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal": "Brand-Alama ya kudumu ambayo ilichomwa kwenye ng'ombe.",
      "tattoOnAnimal": "Tattoo juu ya mnyama.",
      "whetherTheAnimalIsDehorned": "Ikiwa mnyama amekatwa pembe.",
      "milkingAnimals": "Kukamua Wanyama",
      "studAnimals": "Wanyama wa Stud",
      "animalInseminationRecord": "Rekodi ya Kupandikiza Wanyama",
      "numOfStrawsOrdered": "Idadi ya Majani Yaliyoagizwa",
      "totalNumOfStraws": "Jumla ya Idadi ya Majani",
      "strawId": "Kitambulisho cha majani",
      "addSireAutomation": "Ongeza Sire Automation",
      "addApprovalAutomation": "Ongeza Uidhinishaji Kiotomatiki",
      "addCollectionAutomation": "Ongeza Kiotomatiki cha Mkusanyiko",
      "addStrawsAutomation": "Ongeza Mirija Automation",
      "addPackAutomation": "Ongeza Uendeshaji wa Pakiti",
      "addPostageAutomation": "Ongeza Uendeshaji wa Posta",
      "searchBySire": "tafutaKwaSire",
      "numberOfProgenies": "Idadi ya Vizazi",
      "sireEdit": "Bwana Hariri",
      "searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId": "Tafuta kwa Kitambulisho cha Majani, Jumla ya Nambari za majani, Nambari ya Kundi na Kitambulisho cha Mahali",
      "searchByPackIdNumberOfStrawsOrderedPackingTechnicia": "Tafuta kwa Kitambulisho cha Pakiti, Idadi ya majani yaliyoagizwa, Mbinu ya Ufungashaji",
      "searchByCollectionAndPreparationTechnicia": "Tafuta kwa mbinu ya ukusanyaji na utayarishaji",
      "registerSemenAutomation": "Kusajili Shahawa Automation",
      "addSemenAutomation": "Kuongeza Shahawa Automation",
      "strawAutomationRegistered": "Uendeshaji wa Majani Umesajiliwa",
      "strawAutomationRegisteredNotRegistered": "Utengenezaji wa Majani Umesajiliwa haujasajiliwa",
      "sireAutomationRegistered": "Sire Automation Imesajiliwa",
      "sireAutomationNotRegistered": "Sire Automation haijasajiliwa",
      "postageAutomationIsRegistered": "Uendeshaji wa Posta umesajiliwa",
      "postageAutomationNotRegistered": "Posta Automation Haijasajiliwa",
      "packAutomationIsRegistered": "Uendeshaji wa Pakiti umesajiliwa",
      "packAutomationNotRegistered": "Pakiti Kiotomatiki Haijasajiliwa",
      "postageAutomationIsUpdated": "Utumaji wa Posta umesasishwa",
      "postageAutomationNotUpdated": "Utumaji wa Posta Haujasasishwa",
      "packAutomationIsUpadted": "Uendeshaji wa Pakiti Umesasishwa",
      "packAutomationNotUpadted": "Ufungashaji Otomatiki Haujasasishwa",
      "collectionAutomationUpdated": "Mkusanyiko Otomatiki Umesasishwa",
      "collectionAutomationNotUpdated": "Mkusanyiko otomatiki haujasasishwa",
      "approvalAutomationIsUpdated": "Uidhinishaji wa Kiotomatiki umesasishwa",
      "approvalAutomationIsNotUpdated": "Uidhinishaji otomatiki haujasasishwa",
      "collectionAutomationRegistered": "Mkusanyiko Otomatiki Umesajiliwa",
      "collectionAutomationNotRegistered": "Mkusanyiko Otomatiki haujasajiliwa",
      "approvalAutomationIsRegistered": "Uidhinishaji wa Kiotomatiki umesajiliwa",
      "approvalAutomationIsNotRegistered": "Uidhinishaji Kiotomatiki haujasajiliwa",
      "strawAutomationUpdated": "Uendeshaji wa Majani Umesasishwa",
      "strawAutomationIsNotUpdated": "Uendeshaji wa Majani haujasasishwa",
      "searchSire": "Tafuta Bwana",
      "strawsEdit": "Majani Hariri",
      "nextAnimals": "Mnyama Anayefuata",
      "performanceInfo": {
        "milk": "Maziwa",
        "liveweight": "Uzito wa moja kwa moja",
        "score": "Alama",
        "fertility": "Uzazi",
        "measurements": "Vipimo",
        "dailyProteinYield": "Mavuno ya Kila siku ya Protini",
        "amountProteinMilkCowDay": "Kiasi cha protini katika maziwa inayopatikana kutoka kwa ng'ombe kwa siku fulani.",
        "dailyMilkYield": "Mavuno ya maziwa ya kila siku",
        "volumeMilkCowDay": "Kiasi cha maziwa yaliyopatikana kutoka kwa ng'ombe fulani kwa siku fulani.",
        "dailyFatYield": "Mavuno ya mafuta ya kila siku",
        "amountFatMilkCowDay": "Kiasi cha mafuta katika maziwa yaliyopatikana kutoka kwa ng'ombe kwa siku fulani.",
        "dailyProteinContent": "Maudhui ya protini ya kila siku",
        "dailyFatContent": "Maudhui ya mafuta ya kila siku",
        "milkLactose": "Lactose ya maziwa",
        "amountLactoseMilk": "Kiasi cha lactose katika maziwa.",
        "milkUrea": "Urea ya maziwa",
        "indicatorAmountCrudeProtein": "Kiashiria cha kiasi cha protini ghafi katika mlo wa ng'ombe",
        "lactationNumber": "Nambari ya kunyonyesha",
        "ordinalNumLactation": "Nambari ya kawaida ya lactation.",
        "lengthOfLactation": "Urefu wa kunyonyesha (k.m. siku 23)",
        "lactationLength": "Urefu wa kunyonyesha",
        "milkingFrequency": "Mzunguko wa Kunyonyesha",
        "frequcnyOfMilking": "Mzunguko wa kukamua (k.m. mara 2 kwa siku)",
        "liveWeightInformation": "Taarifa za uzito wa moja kwa moja",
        "currentWeight": "Uzito wa Sasa",
        "weightAnimal": "Uzito wa mnyama.",
        "postWeaningGain": "Faida baada ya kuachishwa",
        "dailyGainInAnimalWeightWeaning": "Faida ya kila siku ya uzito wa mnyama baada ya kuachishwa.",
        "weaningWeight": "Uzito wa kunyonya",
        "weightAnimalMeasuredWeaning": "Uzito wa mnyama unaopimwa siku ya kuachishwa kunyonya.",
        "averageDailyGain": "Wastani wa Faida ya Kila Siku",
        "averageAmountWeightAnimalGainFeedingPeriod": "Kiwango cha wastani cha uzito ambacho mnyama atapata kila siku wakati wa kulisha",
        "carcassWeight": "Uzito wa mzoga",
        "weightAnimalsHideInternalOrgansRemoved": "Uzito wa wanyama baada ya kichwa, ngozi na viungo vya ndani vimeondolewa.",
        "weightAtCalving": "Uzito wakati wa kuzaa",
        "weightAtTheTimeOfCalving": "Uzito wakati wa kuzaa.",
        "yearlingWeight": "Uzito wa Mwaka",
        "weightYearOldAnimal": "Uzito wa mnyama wa mwaka mmoja.",
        "somaticCellScore": "Alama ya seli ya Somatic",
        "somaticCellScoreIndicatorMastitis": "Alama ya seli ya kisomatiki kama kiashirio cha kititi. ",
        "lastUpdate": "Sasisho la Mwisho",
        "bodyConditionScore": "Alama ya hali ya mwili",
        "scoreAnimalFat": "Alama ya mnyama kuhusiana na mafuta ngapi anayo.  ",
        "teatScore": "Alama ya matiti",
        "scoreMeasureingShapeTeats": "Alama za ukubwa wa chuchu ni tathmini inayojitegemea ya urefu wa chuchu na mduara na huanzia 9 (ndogo sana) hadi 1 (kubwa sana). ",
        "udderScore": "Alama ya Kusimamishwa kwa Kiwele",
        "scoreMeasureingShapeOfUdder": "Umbo la kupima alama ya kiwele (alama 1-9). ",
        "whetherAnimalEasyBirthDifficult": "Kuzaa kwa mifugo ni jambo la asili lakini wakati mwingine kunaweza kuwa na matatizo ya uzazi ambapo bwawa linahitaji msaada kutoka kwa mkulima/mfugaji.",
        "totalLongevity": "Urefu wa Jumla",
        "survivalLactationTraitCowCulledBreeding": "Uhai kutoka kwa lactation 1 hadi 5. ",
        "docility": "Unyenyekevu",
        "circumferenceBullScrotal": "Mzunguko wa scrotal ya ng'ombe",
        "intervalSuccessInsemination": "Muda kutoka kwa kwanza hadi kufanikiwa kwa upandaji mbegu.",
        "ageAtFirstCalving": "Umri wa Kuzaa Mara ya Kwanza",
        "ageCowCalving": "Ni umri gani wa ng'ombe katika kuzaa kwa kwanza.",
        "calvingInterval": "Muda wa kuzaa",
        "periodCalving": "Kipindi cha kutoka kwa ndama mmoja hadi kuzaa mwingine.",
        "scrotalCircumference": "Mzunguko wa Scrotal",
        "estrusDetection": "Utambuzi wa Estrus",
        "trackingBehaviorAnimalDetectingEstrus": "Kufuatilia tabia ya harakati ya mnyama kwa kugundua estrus ya ng'ombe.",
        "presenceOfEstrus": "Uwepo wa Estrus",
        "isCowInEstrusStage": "Ni wakati ng'ombe yuko kwenye hatua ya estrus au wala",
        "matureWeight": "Uzito Mzima",
        "weightAnimalDefinedAge": "Uzito wa mnyama katika umri maalum.",
        "matureHeight": "Urefu Mzima",
        "heightAnimalDefinedAge": "Urefu wa mnyama katika umri maalum.",
        "footClawSet": "Seti ya Makucha ya Mguu",
        "shapeAnimalClaw": "Sura ya makucha ya mnyama.",
        "pulmonaryArterialPressure": "Shinikizo la Ateri ya Mapafu",
        "animalBloodPreasure": "Shinikizo la damu ya mnyama.",
        "footAngle": "Pembe ya Mguu",
        "shapeAnimalFoot": "Sura ya mguu wa mnyama.",
        "ribEyeArea": "Eneo la mbavu-jicho",
        "amountRibEyeArea": "Kiasi cha eneo la mbavu-jicho.",
        "ultrasoundFat": "Mafuta ya Ultrasound",
        "measureFatAmount": "Kipimo cha kiasi cha mafuta.",
        "ultrasoundIntramuscularFat": "Ultrasound Mafuta ya Ndani ya Misuli",
        "ultrasoundRibEyeArea": "Eneo la Ubavu-Jicho la Ultrasound",
        "measureRibeyeArea": "Kipimo cha eneo la ribeye.",
        "fatThickness": "Unene wa Mafuta",
        "amountAnimalBackFat": "Kiasi cha mafuta ya nyuma ya mnyama.",
        "marbling": "Marbling",
        "marballingMeasurement": "Marbling ni mafuta yanayoonekana yasiyo na saturated (afya) ndani ya misuli ambayo hujilimbikiza ndani ya misuli na kati ya bahasha za nyuzi za misuli.",
        "dryMatterIntake": "Ulaji wa mambo kavu",
        "amountFeedAnimalConsumesAMoisture": "Kiasi cha chakula ambacho mnyama hutumia kwa siku bila unyevu."
      },
      "feedsName": "Jina la Milisho",
      "feedName": "Jina la Kulisha",
      "firstFeedQuantity": "Kiasi cha Chakula cha Kwanza",
      "additionalFeed": "Mlisho wa Ziada",
      "cloversRyeGrasses": "Karafuu, nyasi za Rye",
      "greenFodderHayLegumes": "Lishe ya Kijani, Nyasi, Kunde",
      "feedsRegisteredSuccessfully": "Milisho Imesajiliwa Kwa Mafanikio",
      "feedsNotRegistered": "Milisho Haijasajiliwa",
      "fEEDQUANTITY": "MALISHA KIASI",
      "feedQuantity": "Kiasi cha Kulisha",
      "fEEDNAME": "JINA LA MALISHA",
      "nOFEEDINFOAVAILABLE": "HAKUNA MAELEZO YA MALISHO YANAYOPATIKANA",
      "searchByFeedName": "Tafuta kwa jina la Mipasho",
      "loadingFeedInfo": "Inapakia Maelezo ya Milisho... Tafadhali subiri",
      "todayFeedInfo": "Habari za Milisho ya Leo",
      "feedInfo": "Taarifa za Milisho",
      "loremIpsumDolorSitAmet": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
      "geneticWorthInfo": {
        "breedingValueEconomicIndex": "Iwapo thamani hii ya ufugaji inatumika kukokotoa fahirisi za kiuchumi.",
        "dailyProteinYieldUsed": "Mavuno ya Kila siku ya Protini Hutumika",
        "weightAssignedBreedingDailyProteinYield": "Uzito uliowekwa kwa thamani ya kuzaliana inayolingana na \"Mavuno ya kila siku ya protini\". ",
        "dailyProteinYieldWeight": "Uzito wa Mavuno ya Kila Siku ya Protini",
        "rankAnimalInRelationshipEconomicIndex": "Cheo cha mnyama katika uhusiano na fahirisi ya kiuchumi.",
        "economicIndexRank": "Kiwango cha Kielezo cha Uchumi",
        "percentileEconomicIndexFall": "Asilimia ambayo fahirisi ya uchumi inaangukia.",
        "economicIndexPercentile": "Asilimia ya Kielezo cha Kiuchumi",
        "accuracyOfEconomicIndex": "Usahihi wa index ya kiuchumi.",
        "economicIndexAccuracy": "Usahihi wa Kielezo cha Kiuchumi",
        "weightedAverageOfBreedingValues": "Uzito wa wastani wa maadili ya kuzaliana.",
        "economicIndex": "Kielezo cha Uchumi",
        "rankOfAnimalInRelationshipBreeding": "Cheo cha mnyama katika uhusiano na thamani inayolingana ya ufugaji.",
        "dailyProteinYieldBreedingValueRank": "Kiwango cha thamani ya uzalishaji wa protini ya kila siku ",
        "percentileBreedingFalls": "Asilimia ambayo thamani ya ufugaji inaangukia.",
        "dailyProteinYieldBreedingPercentile": "Thamani ya uzalishaji wa protini ya kila siku kwa asilimia ",
        "accuracyEstimatedBreeding": "Usahihi wa makadirio ya thamani ya kuzaliana.",
        "dailyProteinYieldBreedingAccuracy": "Usahihi wa Thamani ya Uzalishaji wa Mazao ya Kila Siku ya Protini",
        "estimatedBreedingTraitDailyProteinYield": "Thamani iliyokadiriwa ya ufugaji wa sifa \"Mavuno ya kila siku ya protini.",
        "dailyProteinYieldBreedingValue": "Thamani ya Uzalishaji wa Mazao ya Kila Siku ya Protini ",
        "pathToTheDirectoryScriptsBreeding": "Njia ya saraka kwenye diski kuu iliyo na hati ambayo ilitumiwa kuhesabu thamani ya ufugaji.",
        "scriptsPath": "Njia ya Maandishi",
        "softwarePackageBreeding": "Kifurushi cha programu ambacho kilitumika kukokotoa thamani ya ufugaji.",
        "breedingValueSoftware": "Programu ya Thamani ya Uzalishaji",
        "methodCalculateBreeding": "Njia ambayo ilitumika kuhesabu kuzaliana",
        "breedingValueMethod": "Njia ya Thamani ya Ufugaji",
        "trait": "Sifa",
        "tools": "Zana",
        "geneticWorth": "Thamani ya Kinasaba",
        "dailyProteinYield": "Mavuno ya Kila siku ya Protini",
        "breedingValue": "Thamani ya Ufugaji",
        "breedingValueBIFAccuracy": "Thamani ya Uzalishaji BIF Usahihi",
        "breedingValuePercentile": "Asilimia ya Thamani ya Kuzaliana",
        "breedingValueRank": "Kiwango cha Thamani ya Uzalishaji",
        "checkLTD": "Angalia LTD",
        "ultrasoundDiagnostic": "Uchunguzi wa Ultrasound",
        "selectYieldUsed": "Chagua Mazao yaliyotumika",
        "softwareName": "Jina la programu",
        "animalGenWorthUpdatedSuccessfully": "Animal Gen Worth imesasishwa Kwa mafanikio"
      },
      "addNote": "Ongeza Kumbuka",
      "enterNote": "Weka Kumbuka",
      "noteIsRequired": "Kumbuka inahitajika",
      "noteMustBeLessThan50Characters": "Kumbuka lazima iwe chini ya herufi 50",
      "noteAdded": "Kidokezo Kimeongezwa",
      "noteNotAdded": "Kumbuka Haijaongezwa",
      "noteForAnimal": "Kumbuka kwa mnyama.",
      "noNoteFoundForThisAnimal": "Hakuna dokezo lililopatikana la mnyama huyu.",
      "inseminationData": "Data ya Upasuaji",
      "nameOfInseminator": "Jina la inseminator",
      "activity": "Shughuli",
      "searchByNameActivity": "Tafuta kwa jina, shughuli",
      "searchByTaskNameNumber": "Tafuta kwa jina la kazi, nambari",
      "inseminationDate": "Tarehe ya Kupanda mbegu",
      "genotypeDataInfo": {
        "genotypeAnimalID": "Kitambulisho cha Mnyama wa Genotype",
        "iDTubeBloodSampleAnimalNumberGenotypingService": "Hiki ni kitambulisho cha mirija iliyo na sampuli ya damu iliyochukuliwa kutoka kwa mnyama au idadi ya huduma ya uchanganuzi wa jeni",
        "geneticTechnicianName": "Jina la Fundi Jeni",
        "NameTechnicianBloodSamplesAnimal": "Hili ni jina la fundi aliyechukua sampuli za damu kutoka kwa mnyama",
        "sNPData": "Data ya SNP",
        "genotypingServiceNote": "Ujumbe wa Huduma ya Genotyping",
        "InfoGenotypingGenotypingTechnology": "Taarifa zote zinazohusiana na uandishi wa jeni kama vile jina la kampuni ya uandishi wa jeni, teknolojia ya uandishi wa jeni iliyotumika, tarehe ya kuandika jeni, n.k.",
        "numberOfSNPs": "Idadi ya SNP",
        "numberOfSNPsAnimalGenotyped": "Idadi ya SNP ambazo mnyama alichapishwa",
        "nameOfTheDrug": "Jina la Dawa",
        "animalGenoDataUpdatedSuccessfully": "Data ya Geno ya Wanyama Imesasishwa Imefaulu",
        "animalGenoDataNotUpdated": "Data ya Geno ya Wanyama Haijasasishwa",
        "animalIDIsRequired": "Kitambulisho cha mnyama kinahitajika",
        "techNameIsRequired": "Tech. ",
        "onlyAlphabetsAreAllowed": "Alfabeti pekee zinaruhusiwa",
        "genoDataIsRequired": "Data ya Geno inahitajika",
        "serviceNoteIsRequired": "Kumbuka Huduma inahitajika",
        "sNPIsRequired": "SNP inahitajika"
      },
      "healthRecordInfo": {
        "treatment": "Matibabu",
        "treatmentTakenAnimal": "Ni matibabu gani yaliyochukuliwa kwa mnyama.",
        "reasonOfTreatment": "Sababu ya Matibabu",
        "reasonForTreatment": "Sababu ya Matibabu",
        "whatReasonOfTreatment": "Ni nini sababu ya matibabu.",
        "treatmentDate": "Tarehe ya Matibabu",
        "dateOfTreatment": "Tarehe ya matibabu.",
        "diagnosis": "Utambuzi",
        "nameDiagnosedDiseaseConditionSymptoms": "Jina la ugonjwa/hali iliyotambuliwa au dalili kuu",
        "drugID": "Kitambulisho cha dawa",
        "iDOfDrugWhichIsGivenToAnimal": "Kitambulisho cha dawa ambayo hutolewa kwa mnyama.",
        "drugName": "Jina la Dawa",
        "nameDrugAnimal": "Jina la dawa ambayo hutolewa kwa mnyama.",
        "drugWithdrawalPeriod": "Kipindi cha Kuacha Madawa",
        "timeAdministrationDrugAnimalMeatMilkHumanConsumption": "Muda unaohitajika baada ya kumeza dawa kwa mnyama ili kuhakikisha usalama wa nyama au maziwa kwa matumizi ya binadamu",
        "attendingVeterinarian": "Kuhudhuria Daktari wa Mifugo",
        "qualifiedPersonCaseAnimal": "Mtu aliyehitimu ambaye aliona kesi/mnyama",
        "packID": "Kitambulisho cha Pakiti",
        "iDPackTreatment": "Kitambulisho cha pakiti ambayo ilitumika kwa matibabu",
        "veterinarianName": "Jina la Daktari wa Mifugo",
        "animalNoHealthRecord": "Mnyama huyu hana Rekodi yoyote ya Afya. ",
        "addHealthRecord": "Ongeza Rekodi ya Afya",
        "healthStatus": "Hali ya Afya",
        "loadingDiseasesPleaseWait": "Inapakia Magonjwa... Tafadhali subiri",
        "animalDiseaseRecord": "Rekodi ya Magonjwa ya Wanyama",
        "animalHealthRecord": "Rekodi ya Afya ya Wanyama",
        "animalTreatmentRecord": "Rekodi ya Matibabu ya Wanyama",
        "loadingHealthData": "Inapakia Data ya Afya...",
        "healthRecord": "Rekodi ya Afya",
        "nameOfDiagnosis": "Jina la Utambuzi",
        "treatmentName": "Jina la Matibabu",
        "drugGivenBy": "Dawa Iliyotolewa Na",
        "recessiveDiseases": "Magonjwa ya Recessive",
        "recessiveDiseasesMessage": "Ambayo ugonjwa recessive alleles ng'ombe huyu ni carrier wa"
      },
      "conceptionInfo": {
        "addNewConception": "Ongeza dhana mpya",
        "semenEmbryo": "Shahawa/Kiinitete",
        "pregnancyCheck": "Ukaguzi wa Mimba",
        "birthInfo": "Habari ya Kuzaliwa",
        "searchByInseminatorOrganisationBreedingConception": "Tafuta kwa jina la Inseminator, jina la shirika, nambari ya huduma ya kuzaliana, njia ya utungaji",
        "deliveryDate": "Tarehe ya Utoaji",
        "calfId": "Kitambulisho cha ndama",
        "birthDayOldWeight": "Uzito wa kuzaliwa (Siku ya zamani).",
        "searchByBirthEase": "Tafuta kwa urahisi wa Kuzaliwa",
        "searchPregnancyCheckOperatorMethod": "Tafuta na mwendeshaji wa hundi ya ujauzito, Njia ya kuangalia ujauzito",
        "pregnancyCheckDate": "Tarehe ya Uchunguzi wa Mimba",
        "conceptionSuccess": "Mafanikio ya dhana",
        "pregnancyCheckOperator": "Opereta wa Uchunguzi wa Mimba",
        "pregnancyCheckMethod": "Njia ya Uchunguzi wa Mimba",
        "recentlyPregnant": "Hivi karibuni Mjamzito",
        "pregnancyConfirmationDate": "Tarehe ya Uthibitisho wa Mimba",
        "pregnancyRate": "Kiwango cha Mimba",
        "timePeriodOfPregnancy": "Kipindi cha Ujauzito",
        "semenProduction": "Uzalishaji wa Shahawa",
        "embryoProduction": "Uzalishaji wa kiinitete",
        "semen": "shahawa",
        "embryoTransferDate": "Tarehe ya Uhamisho wa Kiinitete",
        "daysOfPregnancy": "Siku za Mimba",
        "searchSireEmbryoSurrogate": "Tafuta kwa kitambulisho cha Sire, jina la shirika la Embryo, aina ya bwawa la Surrogate",
        "selectDate": "Chagua Tarehe",
        "orgnisationNameContainNumber": "Jina la shirika halipaswi kuwa na nambari",
        "selectBirthEase": "Chagua Urahisi wa Kuzaliwa",
        "selectUnit": "Tafadhali chagua kitengo",
        "animalConceptionAddedSuccessfully": "Mimba ya Wanyama Imeongezwa Kwa Mafanikio",
        "postageCustomerName": "Jina la Mteja wa Posta",
        "searchByPostageCustNameCustAddPostId": "Tafuta kwa Jina la Mteja wa Posta, Anwani ya Mteja, Kitambulisho cha Chapisho",
        "dateOfSemenCollection": "Tarehe ya Kukusanya Shahawa",
        "dateOfSemenPreparation": "Tarehe ya Maandalizi ya Shahawa",
        "semenMotility": "Motility ya Shahawa",
        "semenConcentration": "Mkusanyiko wa Shahawa",
        "postageEdit": "Hariri ya Posta",
        "enterSireId": "Ingiza Sire ID",
        "selectEmbryoOrganisation": "Chagua Shirika la Kiinitete",
        "matingDateH": "Tarehe ya mimba, aidha kupandisha asili au insemination bandia.",
        "inseminatorNameH": "Mtu anayefanya mchakato wa kueneza (daktari wa mifugo/fundi)",
        "orgNameH": "Jina la shirika au kampuni inayotoa majani ya shahawa kwa AI",
        "brServiceNumH": "Kurekodi idadi ya kuzaliana (k.m. 1, 2, au 3)",
        "conceptionMethodH": "Njia ambayo mnyama huyo alichukua mimba hiyo ni mwanzo wa ujauzito, unaoonyeshwa na kurutubishwa kwa yai na manii.",
        "sireIdH": "Kitambulisho cha Mwanaume mzazi/baba wa mnyama",
        "damIdH": "Kitambulisho cha mzazi wa kike/mama wa mnyama.",
        "sarogatedDamH": "Kitambulisho cha ng'ombe jike ambamo yai lililorutubishwa kutoka kwa mtoaji dume na jike wafadhili hupandikizwa kwa ajili ya maendeleo yake zaidi.",
        "embOrgNameH": "Jina la shirika la kiinitete",
        "sarogateDamBreedH": "Tarehe ya kuzaliana mbadala",
        "sireBreedH": "Aina ya aina ya baba ( brahman, boran)",
        "pregCheckDateH": "Mimba inaweza kugunduliwa kwa ng'ombe mapema kama siku 30 kwa kutumia ultrasound na vipimo vya damu. Ili ng'ombe kutambuliwa kuwa na mimba kwa kutumia njia ya palpation, ng'ombe mara nyingi wanahitaji kuwa na mimba ya angalau siku 35-50. ",
        "conceptionSuccessH": " Katika ng'ombe, kiwango cha kurutubisha ni 90% na kiwango cha wastani cha kuzaa cha karibu 55%, ikionyesha vifo vya kiinitete cha karibu 35% (Diskin et al., 2006). ",
        "pregnancyCheckOperatorH": "Madaktari wa mifugo na wataalam wa mifugo mara nyingi hutoa huduma hizi kwa wakulima. ",
        "pregnancyCheckMethodH": "Mbinu mbili zinazotumiwa mara nyingi zaidi za utambuzi wa ujauzito wa ng'ombe ni palpation ya njia ya uzazi (kwa kila puru) na uchunguzi wa ultrasound ya njia ya uzazi.",
        "deliveryDateH": "Tarehe ya kujifungua",
        "calfIdH": "Kitambulisho cha ndama aliyezaliwa upya",
        "birthEaseH": "Kuzaa kwa mifugo ni jambo la asili lakini wakati mwingine kunaweza kuwa na matatizo ya uzazi ambapo bwawa linahitaji msaada kutoka kwa mkulima/mfugaji.",
        "birthDayOldWeightH": "Uzito wa mnyama siku ya kuzaliwa au uzito wa ndege wa siku moja",
        "customerAddress": "Anwani ya Mteja"
      },
      "all": "Wote",
      "ungrouped": "Wanyama Wasiokuwa na Makundi",
      "active": "Wanyama Wa Makundi",
      "updateAnimal": "Sasisha Mnyama"
    },
    "dashboardS": {
      "dailyActivities": "Shughuli za Kila Siku",
      "pendingTasks": "Kazi Zinazosubiri",
      "performanceOfGeno": "Utendaji wa Genotypes",
      "breed": "Kuzaliana",
      "chromosome": "Chromosome",
      "seqChange": "Badilisha Mlolongo",
      "inheritance": "Urithi",
      "diseaseName": "Jina la Ugonjwa",
      "refSequence": "Mfuatano wa Marejeleo",
      "pubmedRef": "Rejea Iliyochapishwa",
      "matingDate": "Tarehe ya Kuoana",
      "inseminatorName": "Jina la Inseminator",
      "orgName": "Jina la shirika",
      "brServiceNum": "Nambari ya Huduma ya Ufugaji",
      "conceptionMethod": "Njia ya Kutunga",
      "semEmbInfo": "Maelezo ya Shahawa/Kiinitete",
      "sireId": "Kitambulisho cha Sire",
      "damID": "Kitambulisho cha bwawa",
      "srgDamId": "Kitambulisho cha Bwawa la Surrogate",
      "embOrgName": "Org ya kiinitete. ",
      "srgDamBreed": "Surrogate Dam Breed",
      "sireBreed": "Sire Breed",
      "damBreed": "Dam Breed"
    },
    "user": {
      "selectLanguage": "Chagua Lugha",
      "unitPreference": "Upendeleo wa Kitengo",
      "selectUnitOfMeasure": "Chagua kitengo cha kipimo",
      "importedUser": "Mtumiaji Aliyeingizwa",
      "impFileStatus": "Ingiza Hali ya Faili",
      "loadingUser": "Inapakia Watumiaji... Tafadhali subiri",
      "totalUsers": "Jumla ya Watumiaji",
      "pendingUsers": "Watumiaji Wanaosubiri",
      "changePassword": "Badilisha neno la siri",
      "goodIdeaToUsePassword": "Ni vyema kutumia nenosiri thabiti ambalo hutumii kwingine.",
      "enterCurrentPassword": "Weka Nenosiri la Sasa",
      "enterNewPassword": "Weka Nenosiri Jipya",
      "reEnterPassword": "Weka Tena Nenosiri Jipya",
      "enterPassword": "Weka Nenosiri",
      "repeatNewPassword": "Rudia Nenosiri Jipya",
      "emailAddr": "Barua pepe",
      "enterYourPhoneNumber": "Weka Nambari Yako ya Simu",
      "pleaseTypeOldPassword": "Tafadhali andika nenosiri la zamani.",
      "pleaseTypeNewPassword": "Tafadhali andika nenosiri jipya.",
      "pleaseTypeConfirmPassword": "Tafadhali chapa thibitisha nenosiri.",
      "passwordChangedSuccesFully": "Nenosiri limebadilishwa",
      "currentPassword": "Nenosiri la sasa",
      "newPassword": "Nenosiri Mpya",
      "passwordDoesNotMatch": "Manenosiri hayalingani.",
      "emailCanNotBeEmpty": "Barua pepe haiwezi kuwa tupu",
      "profileUpdated": "Wasifu Umesasishwa",
      "profileNotUpdated": "Wasifu Haujasasishwa",
      "unableToVerifyEmail": "Imeshindwa kuthibitisha Barua pepe",
      "otpSentOnEmail": "OTP imetumwa kwa barua pepe",
      "otpSentSuccessFully": "OTP imetumwa kwa mafanikio",
      "importUsers": "Ingiza Watumiaji",
      "imageUpdated": "Picha Imesasishwa",
      "departmentName": "Jina la Idara",
      "departmentNum": "Nambari ya Idara",
      "departmentAdded": "Idara Imeongezwa",
      "departmentNotAdded": "Idara haijaongezwa",
      "searchDepartnment": "Tafuta kwa Jina la Idara au Nambari",
      "addDepartMent": "Ongeza Idara",
      "addDepartment": "Ongeza Idara",
      "roleNameIsRequired": "Jina la jukumu linahitajika",
      "roleNameMustBeLessThan15Chars": "Jina la jukumu lazima liwe chini ya herufi 15",
      "roleAdded": "Jukumu Limeongezwa",
      "editDepartment": "Idara ya uhariri",
      "departmentUpdated": "Idara Imesasishwa",
      "departmentNotUpdated": "Idara Haijasasishwa",
      "deleteDepartment": "Futa Idara",
      "deleteDepartmentMessage": "Je, una uhakika unataka kufuta idara hii.",
      "noRoleAvailable": "HAKUNA NAFASI INAYOPATIKANA",
      "roleUpdated": "Jukumu Limesasishwa",
      "roleNotUpdated": "Jukumu halijasasishwa",
      "editRole": "Badilisha Jukumu",
      "allRole": "Wajibu Wote",
      "addNewRole": "Ongeza Jukumu Jipya",
      "allDepartment": "Idara zote",
      "permissionsUpdated": "Ruhusa Zimesasishwa",
      "permissionsnotUpdated": "Ruhusa hazijasasishwa",
      "roleNo": "Jukumu No.",
      "searchByEmailAndName": "Tafuta kwa barua pepe na jina",
      "userID": "Kitambulisho cha Mtumiaji",
      "userUpdated": "Mtumiaji Alisasishwa",
      "userNotUpdated": "Mtumiaji Hajasasishwa",
      "userAdded": "Mtumiaji Ameongezwa",
      "userNotAdded": "Mtumiaji Hajaongezwa",
      "activateUser": "Washa Mtumiaji",
      "deactivateUser": "Zima Mtumiaji",
      "userStatusMsg": "Je, una uhakika unataka kubadilisha hali ya mtumiaji",
      "countryRequired": "Nchi inahitajika",
      "stateRequired": "Jimbo linahitajika",
      "cityRequired": "Jiji linahitajika",
      "searchByRole": "Tafuta kwa Nambari ya Wajibu, Jina la Wajibu, Idara",
      "noModuleAvailable": "Hakuna Moduli Inayopatikana",
      "searchBYModuleName": "Tafuta Kwa Jina la Moduli"
    },
    "farm": {
      "farmID": "Kitambulisho cha shamba",
      "onTheFarm": "Kwenye Shamba",
      "userRoles": "Majukumu ya Mtumiaji",
      "adduser": "Ongeza Mtumiaji",
      "addAuser": "Ongeza Mtumiaji",
      "uploadUsers": "Pakia Watumiaji",
      "addNewUser": "Ongeza Mtumiaji Mpya",
      "selectDept": "Idara iliyochaguliwa",
      "selectRole": "Chagua Jukumu",
      "editUser": "Badilisha Mtumiaji",
      "totalFarms": "Jumla ya Mashamba",
      "NoAnimalsRegisteredForthisFarm": "Hakuna Wanyama Waliosajiliwa kwa Shamba hili",
      "farmsPerPage": "Mashamba kwa kila ukurasa",
      "regularFarms": "Mashamba ya Kawaida",
      "farmRegisteredProducts": "Bidhaa Zilizosajiliwa na Shamba",
      "searchByFarmNameAndId": "Tafuta kwa Jina la Shamba na Kitambulisho",
      "loadingProductsPleaseWait": "Inapakia Bidhaa... Tafadhali subiri",
      "farmName": "Jina la Shamba",
      "farmLocation": "Eneo la Shamba",
      "productName": "Jina la bidhaa",
      "stockStatus": "Hali ya Hisa",
      "inStock": "Katika Hisa",
      "searchByProductName": "Tafuta Kwa Jina la Bidhaa",
      "productCategory": "Aina ya Bidhaa",
      "products": "Bidhaa",
      "farms": "Mashamba",
      "registerAfarm": "Sajili Shamba",
      "govtRegistry": "Serikali. ",
      "cooperativeID": "Kitambulisho cha Ushirika",
      "farmType": "Aina ya Shamba",
      "contractMating": "Kuoana kwa Mkataba",
      "customization": "Kubinafsisha",
      "recordsPerpage": "Rekodi kwa kila Ukurasa",
      "restoreDefault": "Rejesha Chaguomsingi",
      "apply": "Omba",
      "searchState": "Tafuta kwa Kitambulisho cha Shamba, Masjala ya Serikali, Kitambulisho cha Ushirika, Aina ya Shamba, Kuoana kwa Mkataba",
      "farmOwner": "Mmiliki wa Shamba",
      "govRegistrationNo": "Nambari ya Usajili ya Serikali",
      "farmInformation": "Habari za shamba",
      "ownershipType": "Aina ya Umiliki",
      "communityName": "Jina la Jumuiya",
      "farmLicenseInformation": "Taarifa ya Leseni ya Shamba",
      "licenseNumber": "Nambari ya Leseni",
      "licenseExpiryDate": "Tarehe ya Kuisha kwa Leseni",
      "regulatorName": "Jina la Mdhibiti",
      "regulatorRepresentativeName": "Jina la Mwakilishi wa Mdhibiti",
      "farmLocationSize": "Eneo la Shamba",
      "productionSystem": "Mfumo wa Uzalishaji",
      "country": "Nchi",
      "state": "Jimbo",
      "city": "Jiji",
      "street": "Mtaa",
      "houseNumber": "Nambari ya Nyumba",
      "farmRegistration": "Usajili wa Shamba",
      "cancel": "Ghairi",
      "register": "Sajili",
      "ok": "sawa",
      "totalFarmSize": "Jumla ya Ukubwa wa Shamba",
      "farmGeographicLocation": "Mahali pa Kijiografia cha Shamba",
      "perimeterPointLongitude": "Urefu wa Pointi ya mzunguko",
      "perimeterPointLatitude": "Latitudo ya Uhakika wa mzunguko",
      "perimeterPointLabel": "Lebo ya Uhakika wa Mzunguko",
      "perimeterLength": "Urefu wa Mzunguko",
      "farmLatitude": "Latitudo ya shamba",
      "farmLongitude": "Urefu wa shamba",
      "editFarm": "Badilisha Shamba",
      "update": "Sasisha",
      "editAfarm": "Hariri shamba",
      "nextFarm": "Kilimo Kinachofuata",
      "nameoftheFarm": "Jina la Shamba",
      "registerAProduct": " Sajili Bidhaa",
      "farmProducts": "Bidhaa za Shamba",
      "calf": "Ndama",
      "steer": "Badili",
      "heifer": "Ng'ombe",
      "sire": "Bwana",
      "dam": "Bwawa",
      "registerAnAnimal": "Kusajili Mnyama",
      "farmAnimals": "Mifugo",
      "farm_type": "Aina ya shamba",
      "farm_Owner": "Mmiliki wa Shamba",
      "dateOfRegistration": "Tarehe ya Usajili",
      "dataIsNotAvailableForThisFarm": "Data Haipatikani kwa Shamba hili",
      "registerNewProduct": "Sajili Bidhaa Mpya",
      "information": "Habari",
      "licenseInfo": "Maelezo ya Leseni",
      "locationInfo": "Maelezo ya Mahali",
      "geoLocation": "Mahali pa Geo",
      "perimeterLengthState": "Urefu wa Mzunguko wa Mashamba (urefu wa uzio)",
      "totalFarmSizeState": "Ukubwa wa Shamba",
      "productionSystemState": "Mfumo wa Uzalishaji unaotumika shambani",
      "contractMatingState": "Kanuni ya Mpango wa Kupandisha Mkataba ambao Shamba Inashiriki.",
      "ownershipTypeState": "Aina ya Umiliki",
      "regulatorRepresentativeNameState": "Jina la mtu anayewakilisha mdhibiti aliyetoa leseni",
      "regulatorNameState": "Jina la mdhibiti aliyetoa leseni",
      "licenseExpiryDateState": "Tarehe ambayo Leseni ya sasa imeisha Muda wake",
      "licenseNumberState": "Nambari ya Leseni iliyotolewa na Mdhibiti",
      "plotNumberState": "Nambari ya nyumba ya shamba.",
      "plotNumber": "Nambari ya Nyumba/Kiwanja",
      "streetStatement": "Jina la mtaa wa shamba.",
      "cityStatement": "Jiji ambalo shamba liko.",
      "stateStatement": "Mkoa wa nchi ambapo shamba liko.",
      "countryState": "Nchi ambayo shamba liko.",
      "perimeterPointLongitudeState": "Urefu wa pointi moja kwenye shamba.",
      "perimeterPointLatitudeState": "Latitudo ya hatua moja kwenye shamba.",
      "perimeterPointLabelState": "Lebo ya Point.",
      "farmLongitudeState": "Longitude ya shamba.",
      "farmLatitudeState": "Latitudo ya shamba.",
      "farmNameH": "Jina la shamba",
      "farmTypeH": "Aina ya shamba ambapo shughuli mbalimbali hufanyika.",
      "farmOwnerH": "Jina la mmiliki wa shamba (jina la kuzalisha kiotomatiki la Mkulima likiingiza maelezo)",
      "ownershipTypeH": "Aina ya wakulima wanaomiliki/kudhibiti ardhi wanayolima na wale wasiomiliki.",
      "govtRegNumbH": "Nambari ya usajili ya shamba ambayo ilitolewa na mdhibiti",
      "contractMatingH": "Kanuni za mpango wa kupandisha mkataba ambao shamba hushiriki",
      "productionSystemH": "Mfumo gani wa uzalishaji unatumika shambani",
      "cooperativeIDH": "Kitambulisho cha ushirika ambacho shamba ni mwanachama ",
      "licenseNumberH": "Nambari ya kutambua kwenye leseni iliyotolewa na mdhibiti ambayo inaitambulisha na mmiliki.",
      "licenseExpiryDateH": "Tarehe ambayo leseni ya sasa imeisha muda wake",
      "regularNameH": "Jina la mdhibiti aliyetoa leseni",
      "regularRepName": "Jina la mtu anayewakilisha mdhibiti aliyetoa leseni",
      "countryH": "Nchi ambayo shamba liko.",
      "stateH": "Mkoa wa nchi ambapo shamba liko.",
      "cityH": "Jiji ambalo shamba liko.",
      "streetH": "Jina la mtaa wa shamba.",
      "houseNumberH": "Nambari ya nyumba ya shamba.",
      "totalFarmSizeH": "Saizi ya shamba ni jumla ya ardhi ambayo inalimwa kwa sasa na shamba ikiwa ni pamoja na ardhi chini ya shamba lakini bila kujumuisha ardhi chini ya uoto wa asili, miti au malisho.",
      "farmLatitudeH": "Ni kipimo cha umbali kaskazini au kusini mwa Ikweta. ",
      "farmLongitudeH": "Inapima umbali mashariki au magharibi mwa meridian kuu.",
      "perimeterLengthH": "Urefu wa mzunguko wa shamba (urefu wa uzio)",
      "perimeterPointLabelH": "Lebo ya uhakika. ",
      "perimeterPointLatH": "Latitudo ya hatua moja kwenye shamba",
      "perimeterPointLongH": "Urefu wa pointi moja kwenye shamba",
      "noProductAvailable": "Hakuna Bidhaa Inayopatikana",
      "farmUpdated": "Shamba Lilisasishwa",
      "performance": "Utendaji",
      "milkInformation": "Taarifa za maziwa",
      "farmNameRequired": "Jina la Shamba linahitajika"
    },
    "login": {
      "welcome": "Karibu! ",
      "welInfo": "Weka kitambulisho chako.",
      "login": "Ingia",
      "forgotPassword": "Umesahau nywila",
      "forgotPasswordDesc": "Tafadhali ingiza anwani ya barua pepe inayohusishwa na akaunti yako. ",
      "backToLogin": "Rudi kwa Ingia"
    },
    "actionListmod": {
      "actionList": "Orodha ya Vitendo",
      "tODAY": "Leo",
      "createTask": "Unda Kazi",
      "myActivities": "Shughuli Zangu",
      "jhonSmith": "Jhon Smith",
      "farmID": "Kitambulisho cha shamba",
      "dateOfEvent": "Tarehe ya Tukio",
      "actionRequired": "Hatua Inahitajika",
      "actionTaken": "Hatua Imechukuliwa",
      "animalEventID": "Kitambulisho cha Tukio la Wanyama",
      "cANCEL": "Ghairi",
      "cONFIRM": "Thibitisha",
      "sTATEMENT": "Je, una uhakika unataka kufuta rekodi hii?",
      "dAY": "Siku",
      "wEEK": "Wiki",
      "mONTH": "Mwezi",
      "sUBMIT": "Wasilisha",
      "startDate": "Tarehe ya Kuanza",
      "endDate": "Tarehe ya mwisho",
      "rEPEAT": "Rudia",
      "taskCategory": "Kitengo cha Kazi",
      "pRIORITY": "Kipaumbele",
      "aSSIGNEE": "Mkabidhiwa",
      "selectLocation": "Chagua eneo",
      "selectAnimals": "Chagua mnyama mmoja au zaidi",
      "dESCRIPTION": "Maelezo",
      "customRecurrence": "Urudiaji Maalum",
      "repeatEvery": "Rudia Kila",
      "taskName": "Jina la kazi",
      "enterDescription": "Ingiza Maelezo",
      "toDo": "Kufanya",
      "assignTo": "Peana Kwa",
      "status": "Hali",
      "nOTE": "Kumbuka",
      "noTaskAvailable": "HAKUNA KAZI INAYOPATIKANA",
      "healthRecord": "Rekodi ya Afya",
      "iD": "ID",
      "tAG": "Lebo",
      "dateOfbirth": "Tarehe ya kuzaliwa",
      "taskTakenat": "Kazi Imechukuliwa",
      "gENDER": "Jinsia",
      "bREED": "Kuzaliana",
      "regDate": "Reg. ",
      "updateHealthRecord": "Sasisha Rekodi ya Afya kwa Wanyama",
      "treatment": "Matibabu",
      "reasonOftreatment": "Sababu ya Matibabu",
      "treatmentDate": "Tarehe ya Matibabu",
      "dIAGNOSIS": "Utambuzi",
      "drugId": "Kitambulisho cha Dawa",
      "drugName": "Jina la Dawa",
      "drugWithdrawalperiod": "Kipindi cha Kuacha Madawa",
      "attendingVeterinarian": "Kuhudhuria Daktari wa Mifugo",
      "packId": "Kitambulisho cha Pakiti",
      "noItemsselected": "Hakuna Vipengee Vilivyochaguliwa",
      "healthRecordsubmission": "Uwasilishaji wa Rekodi za Afya",
      "inseminationRecordsubmission": "Uwasilishaji-Rekodi ya Uingizaji",
      "inseminatorName": "Jina la Inseminator",
      "inseminatorId": "Kitambulisho cha kiingiza",
      "conceptionRate": "Kiwango cha Kutunga",
      "dateOfmeasurement": "Tarehe ya Kipimo",
      "recordSubmission": "Uwasilishaji wa Rekodi",
      "uPDATE": "Sasisha",
      "updateTask": "Sasisha Kazi"
    },
    "inseminatorStatisticsInfo": {
      "addInseminatorInfo": "Ongeza Maelezo ya Inseminator",
      "inseminatorNumber": "Nambari ya Semina",
      "loadingInseminatorPleaseWait": "Inapakia Kiingiza... Tafadhali subiri",
      "searchByIDAndName": "Tafuta kwa Kitambulisho na Jina",
      "inseminatorInfoAdded": "Maelezo ya Inseminator yameongezwa",
      "inseminatorInfoNotAdded": "Maelezo ya Kiingiza Haijaongezwa",
      "inseminatorInfoUpdated": "Maelezo ya Kiingiza Kimesasishwa",
      "inseminatorInfoNotUpdated": "Maelezo ya Kisakinishi hayajasasishwa",
      "editAInseminatorInfo": "Hariri Maelezo ya Kiingiza",
      "inseminatorList": "Orodha ya Inseminator",
      "inseminatorInfoDetails": "Maelezo ya Inseminator",
      "updateInseminatorInfo": "Sasisha Maelezo ya Kiingiza"
    },
    "organizationNtrInfo": {
      "loadingOrdersPleaseWait": "Inapakia Maagizo... Tafadhali subiri",
      "addStocks": "Ongeza Hisa",
      "addStock": "Ongeza Hisa",
      "quantity": "Kiasi",
      "selectUnit": "Chagua Kitengo",
      "farmProducts": "Bidhaa za Shamba",
      "cost": "Gharama",
      "transactionID": "Kitambulisho cha muamala",
      "recipientID": "Kitambulisho cha Mpokeaji",
      "orderID": "Kitambulisho cha agizo",
      "recepientName": "Jina la Mpokeaji",
      "createAOrder": "Unda agizo",
      "totalStocks": "Jumla ya Hisa",
      "orders": "Maagizo",
      "totalPending": "Jumla Inasubiri",
      "totalDelivered": "Jumla Imewasilishwa",
      "searchByRecepientNameOrderIdRecepientId": "Tafuta kwa Jina la Mpokeaji, Kitambulisho cha Agizo, Kitambulisho cha Mpokeaji",
      "chooseTheDate": "Chagua tarehe",
      "transactionDate": "Tarehe ya Muamala",
      "selectCategory": "Chagua Kategoria",
      "volumeOfProduct": "Kiasi cha Bidhaa",
      "productQuantity": "Kiasi cha Bidhaa",
      "productRecipientId": "Kitambulisho cha Mpokeaji Bidhaa",
      "productRecipientName": "Jina la Mpokeaji Bidhaa",
      "productRecipientType": "Aina ya Mpokeaji wa Bidhaa",
      "singleProduct": "Bidhaa Moja",
      "orderPlaced": "Agizo Limewekwa",
      "orderNotPlaced": "Agizo halijawekwa",
      "totalPrice": "Bei jumla",
      "currency": "Sarafu",
      "selectCurrency": "Chagua Sarafu",
      "address": "Anwani",
      "enterAddress": "Weka Anwani",
      "attachments": "Viambatisho",
      "chooseFile": "Chagua Faili",
      "nameOfTheFarm": "Jina la shamba",
      "loremIpsumHasBeenTheIndustrySStandardDummyText": "Lorem Ipsum imekuwa maandishi ya kawaida ya tasnia tangu miaka ya 1500, wakati printa isiyojulikana ilipochukua",
      "billedTo": "Inatozwa Kwa",
      "orderStatus": "Hali ya Kuagiza",
      "selectStatus": "Chagua Hali",
      "cadbury": "Cadbury",
      "totalAmount": "Jumla",
      "deliveryCharges": "Malipo ya Uwasilishaji",
      "orderDetails": "Maelezo ya Agizo",
      "deliveryOnTime": "Uwasilishaji kwa Wakati",
      "productID": "Kitambulisho cha bidhaa",
      "productRegistration": "Usajili wa Bidhaa",
      "enterTheNameOfTheProduct": "Ingiza jina la bidhaa",
      "nameOfTheProduct": "Jina la Bidhaa",
      "productAdded": "Bidhaa Imeongezwa",
      "productNotAdded": "Bidhaa haijaongezwa"
    },
    "drug": {
      "dRUGS": "Madawa",
      "registerAdrug": "Sajili Dawa",
      "sEARCH": "Tafuta",
      "genericName": "Jina la kawaida",
      "manufacturer": "Mtengenezaji",
      "distributor": "Msambazaji",
      "registrationDate": "Tarehe ya Usajili",
      "drugRegistration": "Usajili wa Dawa",
      "drugInformation": "Taarifa za Dawa",
      "packExpiration": "Kuisha kwa Pakiti",
      "drugId": "Kitambulisho cha dawa",
      "drugName": "Jina la Dawa",
      "drugGenericname": "Jina la kawaida la dawa",
      "drugManufacturer": "Mtengenezaji wa Dawa",
      "distributorName": "Jina la Msambazaji",
      "drugRegistrationdate": "Tarehe ya Usajili wa Dawa",
      "nextDrug": "Dawa Inayofuata",
      "editDrug": "Hariri Dawa",
      "updateDrug": "Sasisha Dawa",
      "deleteDrug": "Futa Dawa",
      "noRecordfound": "Hakuna Rekodi Imepatikana",
      "addDrug": "Ongeza Dawa",
      "statementDrug": "Dawa hiyo imefutwa.  ",
      "cANCEL": "Ghairi",
      "cONFIRM": "Thibitisha",
      "sTATEMENT": "Je, una uhakika unataka kufuta rekodi hii?",
      "ok": " sawa",
      "information": "Habari",
      "packOrder": "Pakiti Agizo",
      "packPrescription": "Maagizo ya Pakiti",
      "packReservation": "Uhifadhi wa Pakiti",
      "packLocation": "Eneo la Pakiti",
      "drugDozedam": "Kipimo cha Dawa kwa Siku Kwa Bwawa",
      "drugDozecalf": "Kipimo cha Dawa kwa Siku kwa Ndama",
      "drugFormate": "Muundo wa Dawa",
      "drugDistributor": "Msambazaji wa Dawa",
      "drugActiveingridents": "Viambatanisho vya Kutumika kwa Dawa",
      "drugSubstitutionId": "Kitambulisho cha Ubadilishaji Dawa",
      "packId": "Kitambulisho cha Pakiti",
      "packBatchNumber": "Pakiti Nambari ya Kundi",
      "drugIdStatement": "Nambari ya kundi la dawa.",
      "drugNameSatement": "Jina la chapa iliyotangazwa ambayo dawa inauzwa chini yake.",
      "drugGenericnameStatement": "Muundo wa kemikali wa dawa badala ya jina la chapa iliyotangazwa ambapo dawa hiyo huuzwa.",
      "drugFormateSatement": "Nambari ya kundi la dawa.",
      "drugDozecalfSatement": "Kujua kiasi cha dozi ya dawa kwa ndama.",
      "drugDozedamStatement": "Kujua kiasi cha dozi ya dawa kwa bwawa.",
      "drugManufacturerStatement": "Maelezo ya mtengenezaji wa dawa.",
      "drugDistributorStatement": "Maelezo ya msambazaji wa dawa.",
      "drugRegistrationdateStatement": "Tarehe ya usajili wa dawa katika nchi maalum.",
      "drugActiveingridentsStatement": "Orodha ya viungo vinavyofanya kazi.",
      "drugSubstitutionIdStatement": "Vitambulisho vya mbadala vinavyowezekana vya dawa ikiwa dawa kuu haipatikani kwa sasa.",
      "packIdStatement": "Msimbo wa upau au Kitambulisho cha RF cha pakiti.",
      "packBatchNumberStatement": "Nambari ya bechi iliyopewa kifurushi na mtengenezaji.",
      "locationWarehouseID": "Kitambulisho cha Ghala la Mahali",
      "locationWarehouseIDState": "Kitambulisho cha ghala ambapo pakiti imehifadhiwa.",
      "locationRackID": "Kitambulisho cha Rafu ya Mahali",
      "locationRackIDStatement": "Kitambulisho cha rack ambapo pakiti imehifadhiwa.",
      "locationTierID": "Kitambulisho cha Kiwango cha Mahali",
      "locationTierIDStatement": "Kitambulisho cha safu kwenye rack ambapo pakiti imehifadhiwa.",
      "locationPositionID": "Kitambulisho cha Nafasi ya Mahali",
      "locationPositionIDStatement": "Kitambulisho cha nafasi kwenye safu ambapo pakiti imehifadhiwa.",
      "storageTemperatureCondition": "Hali ya Joto la Uhifadhi",
      "storageTemperatureConditionStats": "Hali ya uhifadhi wa pakiti.",
      "containerForm": "Fomu ya Kontena",
      "containerFormStatement": "Fomu ya chombo ambacho dawa hiyo ilipakiwa.",
      "consistQuantity": "Jumuisha Kiasi",
      "consistQuantityStatement": "Kiasi cha vidonge, chupa, nk kwenye pakiti.",
      "releaseId": "Kitambulisho cha Kutolewa",
      "releaseIdStatement": "Kitambulisho kilichotolewa baada ya pakiti kinachukuliwa na mkulima.",
      "releaseDate": "Tarehe ya kutolewa",
      "releaseDateStatement": "Tarehe ambayo pakiti ilichukuliwa kutoka kwa hisa na mkulima.",
      "packManufacturedDate": "Pakiti Tarehe ya Kutengenezwa",
      "packManufacturedDateStatement": "Tarehe wakati pakiti ilitengenezwa.",
      "packImportedDate": "Pakiti Tarehe ya Kuingizwa",
      "packImportedDateStatement": "Tarehe wakati kifurushi kililetwa.",
      "packExpirationDate": "Tarehe ya Kuisha kwa Pakiti",
      "packExpirationDateStatement": "Tarehe wakati kifurushi kimeisha muda wake.",
      "expiredSoonFlag": "Bendera Imeisha Muda Hivi Karibuni",
      "expiredSoonFlagState": "Onyo kuhusu kifurushi kuisha muda wake hivi karibuni.",
      "packTotalVolumeLeft": "Pakia Jumla ya Kiasi Kushoto",
      "packTotalVolumeLeftState": "Jumla ya idadi ya vifurushi vilivyo na viungo sawa vilivyosalia kwenye hisa.",
      "packOrderID": "Kitambulisho cha Agizo cha Pakiti",
      "packOrderIDState": "Kitambulisho ambacho kilitolewa baada ya kuagiza kifurushi kutoka kwa msambazaji.",
      "packQuantityOrdered": "Kiasi cha Pakiti Kilichoagizwa",
      "packQuantityOrderedState": "Idadi ya vifurushi vilivyoagizwa kutoka kwa msambazaji.",
      "packPrice": "Bei ya Pakiti",
      "packPriceStatement": "Bei ya pakiti.",
      "priceCurrency": "Sarafu ya Bei",
      "packPricecurrency": "Pakiti Bei Sarafu",
      "packPricecurrencyState": "Jina la sarafu ambalo bei imeteuliwa.",
      "packPaydate": "Tarehe ya Kulipa Pakiti",
      "payDate": "Tarehe ya Malipo",
      "packPaydateState": "Tarehe ambayo malipo yalitolewa kwa msambazaji.",
      "packShippingID": "Kitambulisho cha Usafirishaji wa Pakiti",
      "shippingID": "Kitambulisho cha usafirishaji",
      "packShippingIdState": "Kitambulisho cha usafirishaji cha kifurushi kinapowasili kutoka kwa msambazaji.",
      "packShippingDate": "Tarehe ya Kusafirisha Pakiti",
      "shippingDate": "Tarehe ya Kusafirisha",
      "packShippingDateState": "Tarehe ya kuwasili kwa kifurushi kwenye hisa.",
      "packOrderStatus": "Pakiti Hali ya Agizo",
      "packOrderStatusState": "Hali ya utaratibu wa sasa.",
      "recepientKeeperId": "Kitambulisho cha Mlinzi wa Mpokeaji",
      "recepientKeeperIdStatement": "Jina la mtu binafsi/shirika lililopokea kifurushi.",
      "recepientFarmId": "Kitambulisho cha Shamba la Mpokeaji",
      "recepientFarmIdStatement": "Kitambulisho cha shamba ambalo kipokezi cha dawa ya wanyama kinamilikiwa.",
      "recepientAnimalId": "Kitambulisho cha Mnyama wa Mpokeaji",
      "recepientAnimalIdState": "Kitambulisho cha mnyama ambaye dawa (pakiti) iliagizwa.",
      "specialistComments": "Maoni ya Wataalamu",
      "specialistCommentsState": "Maoni ya mtaalamu/daktari wa mifugo kuhusu dawa.",
      "specialistName": "Jina la Mtaalamu",
      "specialistNameState": "Jina la mtaalamu/daktari wa mifugo aliyeagiza dawa hiyo.",
      "specialistID": "Kitambulisho cha Mtaalamu",
      "specialistIDState": "Kitambulisho cha mtaalamu/daktari wa mifugo aliyeagiza dawa hiyo.",
      "reservedByKeeperId": "Imehifadhiwa na Kitambulisho cha Mlinzi",
      "reservedByKeeperIdState": "Kitambulisho cha mlinzi cha aliyehifadhi kifurushi.",
      "reservedByFarmId": "Imehifadhiwa na Kitambulisho cha Shamba",
      "reservedByFarmIdState": "Kitambulisho cha shamba ambacho kilihifadhi pakiti yake.",
      "reservationTimeoutDate": "Tarehe ya Kuisha kwa Nafasi",
      "reservationTimeoutDateState": "Tarehe ambapo uwekaji nafasi utaghairiwa kiotomatiki ikiwa kifurushi hakijanunuliwa.",
      "reservationTimeout": "Muda wa Kuhifadhi Umeisha",
      "reservationTimeoutState": "Idadi ya saa ambapo uhifadhi utaghairiwa kiotomatiki ikiwa kifurushi hakijanunuliwa au kuchukuliwa",
      "reservationDate": "Tarehe ya Kuhifadhi",
      "reservationDateState": "Tarehe ya kuweka nafasi ya pakiti.",
      "reservationStatus": "Hali ya Uhifadhi",
      "reservationStatusState": "Hali ya uhifadhi wa pakiti. ",
      "loadingDrugsPleaseWait": "Inapakia Madawa... Tafadhali subiri",
      "quantityOrder": "Agizo la Kiasi",
      "keeperID": "Kitambulisho cha Mlinzi",
      "timeoutDate": "Tarehe ya Kuisha",
      "warehouseID": "Kitambulisho cha ghala",
      "rackID": "Kitambulisho cha Rack",
      "tierID": "Kitambulisho cha daraja",
      "positionID": "Kitambulisho cha nafasi",
      "temperatureCondition": "Hali ya Joto",
      "manufactureDate": "Tarehe ya utengenezaji",
      "importedDate": "Tarehe Iliyoingizwa",
      "totalVolumeLeft": "Jumla ya Sauti Kushoto"
    },
    "reports": {
      "myReports": "Ripoti Zangu",
      "satelliteReports": "Ripoti za Satellite",
      "weatherReports": "Ripoti za hali ya hewa",
      "pregnancyAnalytics": "Uchanganuzi wa Mimba",
      "semenEmbroyAnalytics": "Uchanganuzi wa Shahawa/Embroy",
      "semenAnalytics": "Uchanganuzi wa shahawa",
      "embryoAnalytics": "Uchambuzi wa kiinitete",
      "calfAnalytics": "Uchambuzi wa Ndama",
      "milkProduction": "Uzalishaji wa Maziwa",
      "totalMilkType": "Jumla ya Aina ya Maziwa",
      "totalAnimalAnalytics": "Jumla ya Takwimu za Wanyama",
      "animalAnalytics": "Uchambuzi wa Wanyama",
      "analyticsAndReporting": "Uchanganuzi na Kuripoti",
      "filterByCountry": "Chuja Kwa Nchi",
      "filterByFarm": "Chuja Kwa Shamba",
      "filterByRegion": "Chuja Kwa Mkoa",
      "filterByMonth": "Chuja Kwa Mwezi",
      "filterByDate": "Chuja Kwa Tarehe",
      "filterByRole": "Chuja Kwa Wajibu",
      "filterByYear": "Chuja Kwa Mwaka",
      "filterByTrait": "Chuja Kwa Sifa",
      "avgBreedingValue": "Thamani ya wastani ya kuzaliana",
      "avgEconomicIndex": "Kielezo cha wastani cha Uchumi",
      "breederReport": "Ripoti ya Mfugaji",
      "semenTransferDate": "Tarehe ya uhamisho wa shahawa",
      "semenEmbryoProductionReport": "Ripoti ya Uzalishaji wa Shahawa/Kiinitete",
      "semenProducts": "Bidhaa za Shahawa",
      "meatProducts": "Bidhaa za Nyama",
      "totalProducts": "Jumla ya Bidhaa",
      "semenEmbryoReport": "Ripoti ya Shahawa/Kiinitete",
      "numOfStraws": "Idadi ya Majani",
      "collectionDate": "Tarehe ya Mkusanyiko",
      "productionReport": "Ripoti ya Uzalishaji",
      "receipientId": "Kitambulisho cha mpokeaji",
      "embryoId": "Kitambulisho cha kiinitete",
      "semenStrawId": "Kitambulisho cha Majani ya Shahawa",
      "dataScientist": "Mwanasayansi wa Takwimu",
      "dataScientistReport": "Ripoti ya Mwanasayansi wa Data",
      "productReport": "Ripoti ya Bidhaa",
      "dairyProducts": "Bidhaa za Maziwa"
    },
    "genoPerformance": {
      "performanceOfGenoType": "Utendaji wa GenoType",
      "addAGenoType": "Ongeza GenoType",
      "breedName": "Jina la Uzazi",
      "chromosome": "Chromosome",
      "sequenceChange": "Badilisha Mlolongo",
      "inheritance": "Urithi",
      "diseaseName": "Jina la Ugonjwa",
      "referenceSequence": "Mfuatano wa Marejeleo",
      "pubmedReference": "Rejea Iliyochapishwa",
      "genoTypeRegistration": "Usajili wa GenoType",
      "breed": "Kuzaliana",
      "editAGenoType": "Hariri GenoType",
      "editGenoType": "Hariri GenoType",
      "loadingGene": "Inapakia Geno... Tafadhali subiri",
      "geneTypeList": "Orodha ya GenoType"
    },
    "reportings": {
      "conception": "Dhana (Mwanasayansi wa Data)",
      "performanceOfGenoData": "Utendaji wa Genotype(Mwanasayansi wa Data)",
      "totalInsemination": "Uingizaji wa Jumla",
      "embryo": "Kiinitete",
      "animalVaccinationRecord": "Rekodi ya Chanjo ya Wanyama",
      "dataNotAvailable": "Data Haipatikani kwa Shamba hili.",
      "pregnancyStatus": "Hali ya Mimba",
      "healthReport": "Ripoti ya Afya",
      "heavyMilk": "Maziwa Mazito",
      "standardMilk": "Maziwa ya kawaida"
    },
    "sidebar": {
      "healthAnalytics": "Uchanganuzi wa Afya",
      "productionAnalytics": "Uchanganuzi wa Uzalishaji"
    },
    "epd": {
      "regNo": "Nambari ya nambari ya wanyama ni nambari ya kipekee inayotolewa kwa mnyama kwa kutumia njia ya kuweka alama, kuhakikisha mchakato unafanywa kutambua na kufuatilia wanyama mahususi.",
      "internationalID": "Kitambulisho cha Kimataifa cha Wanyama",
      "location": "Nchi / Eneo la Kuzaliwa kwa Wanyama ",
      "animalName": "Jina la Kawaida / Nomenclature ya Mnyama",
      "gender": "Jinsia ya mnyama (mwanaume/jike)",
      "additionalIDMethod": "Ni njia gani ilitumika kutambua mnyama (k.m. lebo ya sikio, tattoo)",
      "damID": "Kitambulisho au Nambari ya Usajili ya bwawa la mnyama-mzazi wa kike wa mnyama/Kitambulisho cha Nambari ya mama mzazi.",
      "sireId": "Kitambulisho au Nambari ya Usajili ya mzazi wa kiume wa mnyama, hasa fahali anayefugwa kwa ajili ya kuzaliana au shahawa za ng'ombe zinazotumiwa kwa Uhimilishaji Bandia.",
      "dateOfBirth": "Tarehe ya kuzaliwa kwa mnyama.",
      "breederHerdCode": "Msimbo wa Kundi la Wafugaji hutolewa zaidi na Vyama vya Wafugaji",
      "seasonofBirth": "Msimu wa Kuzaliwa kwa Wanyama ulibainishwa kwa busara ya mwezi",
      "birthYear": "Mwaka wa kuzaliwa kwa mnyama",
      "birthManagementCode": "Kanuni ya Kudhibiti Uzazi hutolewa zaidi na mtumiaji/mkulima",
      "birthSex": "Jinsia ya mnyama (mwanaume/jike)",
      "birthWeight": "Uzito wa Kuzaliwa kwa Ndama ",
      "primaryBreed": "% Mchango wa kimaumbile wa mnyama ",
      "secondaryBreed": "% Ndogo Mchango wa kimaumbile wa mnyama ",
      "breedComposition": "Asilimia ya utungaji wa mifugo inarejelea uwakilishi sawia wa mifugo tofauti ndani ya muundo wa kijeni wa mnyama mmoja mmoja au kundi la wanyama. ",
      "conceptionMethod": "Jinsi mnyama alivyotungwa (kupanda kwa asili/ upandishaji/uhamisho wa kiinitete).",
      "accuracyWeight": "Uzito wa Usahihi",
      "damAge": "Umri wa bwawa katika miezi/miaka k.m. ",
      "weaningWeight": "Kuachisha kunyonya Uzito wa mnyama wakati wa kumwachisha kunyonya.",
      "weaningDate": "Tarehe ambayo mnyama aliachishwa kunyonya",
      "weaningSex": "Jinsia ya mnyama aliyeachishwa kunyonya. ",
      "managementPastureCode": "Kanuni iliyotolewa kwa usimamizi/ malisho na mtumiaji/mkulima ",
      "creep": "Kulisha wanyama watambaao ni desturi ya kutoa chakula cha ziada (nafaka au malisho) kwa ndama wanaonyonyesha.",
      "weaningContemporaryGroupCode": "Kanuni za Kikundi cha Kisasa cha Kuachisha Uzito",
      "birthContemporaryCode": "Msimbo wa Kisasa wa Kuzaliwa",
      "yearlingDate": "Tarehe ya mnyama mwenye umri wa mwaka mmoja au katika mwaka wa pili wa umri wake",
      "managementFeedUnitCode": "Msimbo uliotolewa kwa kitengo cha usimamizi/mlisho na mtumiaji",
      "yearlingSex": "Jinsia ya mnyama wakati wa mwaka ",
      "yearlingWeight": "Uzito wa Mwaka ni kipimo cha ukuaji wa moja kwa moja baada ya kuachishwa kunyonya na mara nyingi hutumiwa kuonyesha utendaji unaowezekana wa kizazi kinachofungamana na soko katika sehemu ya malisho, inayopimwa kwa pauni za ndama.",
      "yearlingHeight": "Urefu wa mnyama wakati wa mwaka ",
      "yearlingWeightContemporaryGroupCode": "Kanuni za Kikundi cha Kisasa cha Uzito wa Mwaka",
      "weaningYearlingWeightContemporaryGroupCode": "kanuni za Kuachisha ziwa au Yearling Weight Contemporary Group",
      "daysOnFeed": "Idadi ya siku zinazolishwa na chakula hicho Ex: ng'ombe wachanga wanaokua hulishwa chakula chenye nguvu nyingi ili kuzalisha nyama ya ng'ombe inayouzwa kwa gharama ya chini ya faida. ",
      "managementFeedUnitPenCode": "Nambari iliyotolewa kwa kitengo cha usimamizi/mlisho/kalamu na mtumiaji",
      "harvestDate": "Tarehe ya kuchinjwa kwa mnyama (kuuawa) kwa ajili ya nyama",
      "gradingDate": "Tarehe ya mizoga ilipangwa kulingana na vigezo fulani",
      "carcassSex": "Jinsia ya mzoga",
      "dateonFeed": "Tarehe ambayo mnyama alihamishiwa kwenye malisho mapya Mf: ng'ombe wachanga wanaokua wanalishwa chakula chenye nguvu nyingi ili kuzalisha nyama ya ng'ombe inayouzwa kwa gharama nafuu. ",
      "KPH": "% KPH ni asilimia ya jumla ya mafuta yanayopatikana kwenye patiti la mwili wa mzoga hasa katika maeneo ya figo, pelvisi na moyo. ",
      "carcassWeight": "Uzito wa mzoga ni uzito wa moto au usiopungua baada ya kuvuna na kuondolewa kwa ngozi, kichwa, njia ya utumbo na viungo vya ndani. ",
      "fatThickness": "Unene wa mafuta hupimwa kwa inchi kwa kutumia rula ndogo. ",
      "marbling": "Marbling ni mafuta yanayoonekana yasiyo na saturated (afya) ndani ya misuli ambayo hujilimbikiza ndani ya misuli na kati ya bahasha za nyuzi za misuli.",
      "ribeyeArea": "Kiasi cha eneo la ubavu-jicho (loin au ribeye muscle longissimus dorsi) lililopimwa kati ya mbavu za 12 na 13 katika inchi za mraba kwa kutumia gridi ya taifa (k.m., inchi 8, 9 au 10). ",
      "animalStatus": "Hali ya mnyama shambani k.m: mwenye afya njema, mgonjwa n.k"
    },
    "manageAnimalGroupings": {
      "resetModeTooltip": "\n        WEKA UPYA MODI <br>\n            Katika hali hii <br>\n            1) Weka / fafanua sifa zote za vikundi vya kisasa (CGs) kwa sifa zote zinazovutia. <br>\n            2) Wape wanyama wote kwa CG inayolingana. <br>\n            3) Ikiwa ugawaji wa wanyama hauridhishi, rekebisha / ubadilishe CG, na kisha uwape wanyama kwa CG mpya zinazolingana. <br>\n            4) Rudia hatua zilizo hapo juu, ikiwa ni lazima, hadi utakaporidhika na CGs na upangaji / ugawaji wa wanyama sambamba.<br>\n        ",
      "maintainanceModeHeadingTooltip": "Baada ya KUWEKA UPYA (modi) kukamilika, utaingiza HALI YA UTENGENEZAJI ambapo EDP zilizokokotolewa katika KUREJESHA UPYA zitawekwa mara kwa mara kwa kila mnyama hadi UPYA ufuatao (ambao unaweza kuwa umbali wa miezi 2-6). ",
      "maintainanceModeTooltip": "Baada ya kukamilisha HALI YA KUWEKA UPYA, bonyeza kitufe IMEMALIZA UPYA ili kuwezesha mfumo kukokotoa EPD za wanyama wote, Simamisha HALI YA KUWEZA UPYA, na uanzishe HALI YA UTENGENEZAJI.",
      "resetToggleTooltip": "Washa Badilisha Upya katika mpangilio wa muundo wa EPD ili kukabidhi wanyama kwa CGs."
    },
    "geneticsAndBreeding": {
      "geneticsAndBreeding": "Jenetiki",
      "geneticSearchTool": "Zana ya Utafutaji Jeni",
      "dataSubmission": "Uwasilishaji wa data / Uchaguzi wa Wanyama",
      "animalsWithExpectedProgenyDifferences": "Uhesabuji wa Uchaguzi wa Wanyama kwa Tofauti Zinazotarajiwa za Vizazi (EPDs).",
      "searchByAnimalIdName": "Tafuta kwa Kitambulisho cha Mnyama, Jina",
      "rowsPerPage": "Safu kwa kila ukurasa",
      "individualEntry": "Kuingia kwa Mtu binafsi",
      "bulkEntry": "Kuingia kwa Wingi",
      "registerANewAnimalOrSelectAnExistingAnimal": "Sajili mnyama mpya au chagua mnyama aliyepo.",
      "registerNewAnimal": "Sajili Mnyama Mpya",
      "selectExistingAnimal": "Chagua Mnyama Aliyepo",
      "animalID": "Kitambulisho cha Mnyama",
      "animalName": "Jina la Mnyama",
      "tag": "Lebo",
      "dateOfBirth": "Tarehe ya kuzaliwa",
      "gender": "Jinsia",
      "birthDate": "Tarehe ya kuzaliwa",
      "birthWeightLb": "Uzito wa Kuzaliwa (lb)",
      "birthWeightKg": "Uzito wa Kuzaliwa (kg)",
      "weaningWeightLb": "Uzito wa kunyonya (lb)",
      "weaningWeightKg": "Uzito wa kunyonya (kg)",
      "yearlingWeightLb": "Uzito wa Mwaka (lb)",
      "yearlingWeightKg": "Uzito wa Mwaka (kg)",
      "carcassWeightLb": "Uzito wa Mzoga (lb)",
      "carcassWeightKg": "Uzito wa Mzoga(kg)",
      "animalSelection": "Uchaguzi wa Wanyama",
      "animalSearchTool": "Zana ya Kutafuta Wanyama",
      "back": "Nyuma",
      "searchByEPDs": "Tafuta kwa EPDs",
      "searchByIds": "Tafuta kwa Vitambulisho",
      "selectBreed": "Chagua Kuzaliana",
      "selectGender": "Chagua Jinsia",
      "selectRequiredBreedForCattle": "Chagua Ufugaji Unaohitajika kwa Ng'ombe",
      "resetFilter": "WEKA UPYA KICHUJI",
      "birthWeightHeader": "Uzito wa Kuzaliwa (BW): ",
      "birthWeightDef": "Inalinganisha tofauti za uzito wa ndama wakati wa kuzaliwa na hupimwa kwa paundi au kilo.",
      "weaningWeightHeader": "Uzito wa kunyonyesha (WW): ",
      "weaningWeightDef": "WW EPD ni makadirio ya ukuaji wa kabla ya kuachishwa kunyonya ambayo hupimwa kwa pauni au kilo.",
      "yearlingWeightHeader": "Uzito wa Mwaka (YW): ",
      "yearlingWeightDef": "YW EPD ni makadirio ya ukuaji baada ya kuachishwa kunyonya ambayo hupimwa kwa pauni au kilo.",
      "ribEyeAreaHeader": "Eneo la Ribeye(REA): ",
      "ribEyeAreaDef": "REA hupima ukubwa wa misuli inayotupa ribeye katika inchi za mraba.EPD za REA huakisi tofauti katika kipimo kilichorekebishwa cha siku 365 cha eneo la ribeye kulingana na vipimo vya mizoga ya ng'ombe waliovunwa.",
      "marblingHeader": "Marbling (MARB): ",
      "marblingDef": "MARB EPD iko katika vitengo vya asilimia ya mafuta ya ndani ya misuli ndani ya ribeye.MARB EPDs huakisi tofauti katika alama ya marumaru ya siku 365 (mafuta ya ndani ya misuli, [IMF]) kulingana na vipimo vya mizoga ya ng'ombe waliovunwa.",
      "fatThicknessHeader": "Unene wa mafuta (FAT): ",
      "fatThicknessDef": "Inchi za backfat (katika hundredths ya inchi) ni kitengo cha kipimo cha FT.",
      "carcassWeightHeader": "Uzito wa Mzoga(CW): ",
      "carcassWeightDef": "Uzito wa mzoga ni sifa ya manufaa wakati wa kuzingatia athari ambazo paundi zinahusiana na thamani ya mwisho ya bidhaa. ",
      "yieldGradeHeader": "Kiwango cha Mavuno(YG): ",
      "yieldGradeDef": "Mfumo wa alama wa Daraja la Mavuno ya USDA ni kitengo cha kipimo cha YG EPD. ",
      "milkHeader": "Maziwa(MK): ",
      "milkDef": "MK EPD hupimwa kwa paundi za uzito wa kunyonya ndama kutokana na uwezo wa mama yake wa kukamua.",
      "totalMaternalHeader": "Jumla ya Mama(TM): ",
      "totalMaternalDef": "TM hupima athari kwa uzito wa ndama wa kuachishwa kunyonya kutokana na uzalishaji wa maziwa na maumbile ya ng'ombe kwa ukuaji.",
      "calvingEaseDirectHeader": "Urahisi wa Kuzaa (CED): ",
      "calvingEaseDirectDef": "CED EPD imeorodheshwa kama asilimia ya ndama wasiosaidiwa.",
      "calvingEaseMaternalHeader": "Urahisi wa Kuzaa (CEM): ",
      "calvingEaseMaternalDef": "Hupima uwezo wa binti za fahali kupata ndama bila kusaidiwa wakiwa na umri wa miaka miwili.",
      "stayabilityHeader": "Uthabiti(KUKAA): ",
      "stayabilityDef": "ST EPD inatabiri uwezo wa fahali kuchunga ng'ombe \"kukaa karibu\". ",
      "docilityHeader": "Utulivu(DOC): ",
      "docilityDef": "DOC hupima temperament ya ng'ombe.",
      "max": "MAX",
      "min": "MIN",
      "accuracy": "USAHIHI",
      "sortBy": "Panga kwa",
      "traits": "Sifa zinazoonyeshwa kwa rangi ya kijivu ziko katika maendeleo, zinakuja katika Q2, 2023.",
      "searchResults": "Matokeo ya Utafutaji",
      "recordsFound": "rekodi zilizopatikana",
      "compareSelected": "LINGANISHA WALIOCHAGULIWA",
      "animalIdentification": "Utambulisho wa Wanyama",
      "errorMessage": {
        "birthWeight": "Thamani ya juu ya uzito wa kuzaliwa haiwezi kuwa chini ya kiwango cha chini cha Uzito wa Kuzaliwa",
        "weaningWeight": "Uzito wa juu wa thamani hauwezi kuwa chini ya kiwango cha chini cha uzito wa Kuachisha kunyonya",
        "yearlingWeight": "Thamani ya juu ya uzito wa mwaka haiwezi kuwa chini ya kiwango cha chini cha uzani wa Mwaka",
        "carcassWeight": "Thamani ya juu ya uzito wa mzoga haiwezi kuwa chini ya kiwango cha chini cha Uzito wa Kuzaliwa",
        "fatThickness": "Thamani ya juu ya Unene wa Mafuta haiwezi kuwa chini ya kiwango cha chini cha uzito wa Kuachisha",
        "marbling": "Thamani ya juu ya marumaru haiwezi kuwa chini ya kiwango cha chini cha uzito wa Mwaka",
        "ribeyeArea": "Thamani ya juu ya Eneo la Ribeye haiwezi kuwa chini ya kiwango cha chini cha uzito wa Kuzaliwa",
        "yieldGrade": "Kiwango cha juu cha thamani ya daraja la mavuno hakiwezi kuwa chini ya kiwango cha chini cha uzito wa Kuachisha kunyonya",
        "milk": "Thamani ya juu ya maziwa haiwezi kuwa chini ya kiwango cha chini cha uzito wa Kuachisha"
      },
      "reg": "Reg",
      "name": "Jina",
      "sex": "Ngono",
      "tattoo": "Tatoo",
      "dob": "DOB",
      "EPD": "EPD",
      "rank": "Cheo",
      "searchValue": "Tafuta Thamani",
      "typeHere": "Andika hapa",
      "searching": "Inatafuta...",
      "fetchingResult": "Inaleta matokeo...Tafadhali subiri",
      "animalsMatchedYourCriteria": "Wanyama Imeendana na Vigezo vyako",
      "manageAnimalsGrouping": "Dhibiti Upangaji Wanyama",
      "manageAnimalGroupings": "Dhibiti Makundi ya Wanyama",
      "assignAnimalToContemporaryGroups": "Agiza Mnyama kwa Vikundi vya Kisasa",
      "resetMode": "Weka Upya Modi",
      "enterResetMode": "Ingiza Hali ya Kuweka Upya",
      "maintainanceMode": "Hali ya Matengenezo",
      "assigningAnimals": "Kukabidhi Wanyama",
      "excludedAnimals": "Wanyama Waliotengwa",
      "ungroupedAnimals": "Wanyama Wasiokuwa na Makundi",
      "assignAnimalsToCGS": "Wape Wanyama kwa CGS",
      "reset": "Weka upya",
      "excludeAnimals": "Kuwatenga Wanyama",
      "resetToMaintainanceMode": "Weka Upya Imekamilishwa - Badilisha hadi Hali ya Matengenezo",
      "contemporaryGroupsSettings": "Mipangilio ya Vikundi vya Kisasa(CG).",
      "selectTrait": "Chagua Tabia",
      "selectTraitDescription": "Chagua Sifa inarejelea mchakato wa kuchagua sifa maalum",
      "traitsType": {
        "birthWeight": "Uzito wa Kuzaliwa",
        "weaningWeight": "Uzito wa kunyonya",
        "yearlingWeight": "Uzito wa Mwaka",
        "carcassWeight": "Uzito wa Mzoga"
      },
      "addNewGroup": "ONGEZA KUNDI JIPYA",
      "contemporaryGroup": "Kikundi cha kisasa",
      "contemporaryGroups": "Vikundi vya kisasa",
      "editGroup": "Badilisha Kikundi",
      "birthCGCode": "Kuzaliwa (CG) Kanuni",
      "groupName": "Jina la Kikundi",
      "birthSex": "Jinsia ya Kuzaliwa",
      "conceptionMethod": "Njia ya Kutunga",
      "weaningCGCode": "Kanuni ya Kuachisha ziwa (CG).",
      "yearlingCGCode": "Nambari ya Mwaka (CG).",
      "dateWeight": "Uzito wa Tarehe",
      "weaningyearlingCGcode": "Kanuni ya Kuachisha/Mwaka(CG).",
      "carcassCGCode": "Msimbo wa Mzoga(CG).",
      "breedOfDom": "Uzazi wa Bwawa",
      "addNewContemporaryGroup": "Ongeza Kikundi Kipya cha Kisasa",
      "createNewGroup": "Unda Kikundi Kipya",
      "selectFromDifferentTraits": "Chagua kutoka kwa sifa tofauti",
      "contemporaryGroupName": "Jina la Kikundi cha kisasa",
      "enterNameHere": "Ingiza jina hapa",
      "groupNameIsRequired": "Jina la Kikundi linahitajika",
      "birthYearRange": "Kiwango cha Mwaka wa Kuzaliwa",
      "theYearAnimalWasBorn": "Mnyama wa mwaka alizaliwa",
      "birthYearIsRequired": "Mwaka wa kuzaliwa unahitajika",
      "genderOfNewBornAnimal": "Jinsia ya mnyama aliyezaliwa",
      "selectSex": "Chagua Ngono",
      "theweightOfAnimalAtBirth": "Uzito wa mnyama wakati wa kuzaliwa",
      "maximumKg": "Upeo wa juu",
      "minimumKg": "Kiwango cha chini",
      "aSeasonisAPeriodOfYear": "Msimu ni kipindi cha mwaka ambacho kinatofautishwa na hali maalum ya hali ya hewa.",
      "seasonofBirthIsRequired": "Msimu wa Kuzaliwa unahitajika",
      "majorGenericContributionOfAnimal": "Asilimia Kuu ya Mchango wa Jumla wa Wanyama",
      "primaryBreedCompostionIsRequired": "Mbolea ya Msingi inahitajika",
      "secondaryBreedCompostionIsRequired": "Mbolea ya Kuzaliana ya Sekondari inahitajika",
      "howTheAnimalWasConceived": "Jinsi mnyama alivyotungwa (kupanda kwa asili/kupanda/kuhamisha kiinitete)",
      "conceptionMethodIsRequired": "Njia ya kutunga mimba inahitajika",
      "epdModelSettings": "Mipangilio ya Muundo wa EPD",
      "forResetMode": "Kwa Modi ya Kuweka Upya",
      "progenyWeightingFactor": "Factor ya Uzani wa kizazi",
      "weightGivenToTheProgenyFactor": "Uzito unaotolewa kwa kipengele cha kizazi kinachohusiana na kipengele cha CG kwa hesabu ya EPD katika hali ya Kuweka Upya. ",
      "enterNumber": "Weka Nambari",
      "enterBreed": "Ingiza Breed",
      "valueShouldBeBetween0and1": "Thamani inapaswa kuwa kati ya 0 na 1",
      "resetDuration": "Weka Muda Upya",
      "timeIntervalBetweenLastAndFirstResetMode": "Muda kati ya modi ya mwisho na mpya ya kuweka upya, ambayo mwisho wake hali mpya ya kuweka upya imewashwa na CG na EPD mpya huhesabiwa.",
      "enterNumberOfDays": "Weka Idadi ya Siku",
      "valueCannotBeNegative": "Thamani haiwezi kuwa hasi!",
      "criticalProgenyPopulation": "Idadi muhimu ya kizazi cha watu",
      "minimumNumberOfProgenyRecords": "Idadi ya chini ya rekodi za vizazi vya mnyama mmoja mmoja kwenye mfumo muhimu ili kufikia Usahihi wa Uzazi (APD1) zaidi ya 50% (kwa Usahihi wa Uzazi)",
      "criticalAncestorPopulation": "Muhimu Babu Idadi ya Watu",
      "minimumNumberOfAncestorsRecords": "Idadi ya chini kabisa ya rekodi za mababu za mnyama binafsi katika mfumo unaohitajika ili kufikia Usahihi wa Babu (APD4) zaidi ya 50% (kwa Usahihi wa Asili)",
      "forBirthWeightCG": "Kwa Uzito wa Kuzaliwa CG",
      "criticalPopulationInAnimalsContemporaryGroup": "Idadi ya Watu Muhimu Katika Kikundi cha Kisasa cha Wanyama",
      "minimumAverageNumberOfAnimalsPerBirthWeight": "Kiwango cha chini cha wastani cha idadi ya wanyama kwa kila Uzito wa Kuzaliwa unaohitajika kufikia Wastani wa Usahihi wa CG (ACG3) zaidi ya 50%",
      "criticalAveragePopulationPerContemporaryGroup": "Wastani Muhimu wa Idadi ya Watu kwa Kikundi cha Kisasa",
      "minimumNumberOfAnimalsInBirthWeight": "Idadi ya chini ya wanyama katika Uzito wa Kuzaliwa wa mnyama inahitajika kufikia Usahihi wa CG (ACG2) zaidi ya 50%",
      "forWeaningWeightCG": "Kwa Weaning Weight CG",
      "minimumAverageNumberOfAnimalsPerWeaningWeight": "Kiwango cha chini cha wastani cha idadi ya wanyama kwa kila uzito wa Kuachisha kunyonya CG muhimu ili kufikia Wastani wa Usahihi wa CG (ACG3) zaidi ya 50%",
      "minimumNumberOfAnimalsInWeaningWeight": "Idadi ya chini ya wanyama katika uzito wa Kuachisha kunyonya kwa mnyama ni muhimu ili kufikia Usahihi wa CG (ACG2) zaidi ya 50%",
      "forYearlingWeightCG": "Kwa Uzito wa Mwaka wa CG",
      "minimumAverageNumberOfAnimalsPerYearling": "Kiwango cha chini cha wastani cha idadi ya wanyama kwa kila CG ya Mwaka inayohitajika ili kufikia Usahihi wa Wastani wa CG (ACG3) zaidi ya 50%",
      "minimumNumberOfAnimalsInYearlingWeight": "Idadi ya chini ya wanyama katika CG ya uzito wa Mwaka wa mnyama inahitajika kufikia Usahihi wa CG (ACG2) zaidi ya 50%",
      "forCarcassCG": "Kwa Carcass CG",
      "minimumAverageNumberOfAnimalsPerCarcassWeight": "Kiwango cha chini cha wastani cha idadi ya wanyama kwa kila uzito wa Mzoga unaohitajika ili kufikia Usahihi wa Wastani wa CG (ACG3) zaidi ya 50%",
      "minimumNumberOFAnimalInCarcassWeight": "Idadi ya chini ya wanyama katika uzito wa Mzoga wa mnyama inahitajika ili kufikia Usahihi wa CG (ACG2) zaidi ya 50%",
      "epdRequiredFieldSettings": "EPD Inahitajika Mipangilio ya Sehemu",
      "pleaseSelectRequiredFieldsForCompleteEPD": "Tafadhali chagua sehemu zinazohitajika kwa hesabu kamili ya EPD",
      "byDefault": "Kwa Chaguomsingi",
      "pleaseNoteThatUsersNotAbleToObtainFullEPD": "Kumbuka: Tafadhali kumbuka kuwa watumiaji hawataweza kupata hesabu kamili ya EPD ikiwa hawatatoa sehemu za data unazotia alama inavyohitajika.",
      "pleaseNoteThatRequiredFieldParametersCannotBeChanged": "Kumbuka: Tafadhali kumbuka kuwa vigezo vya sehemu vinavyohitajika haviwezi kubadilishwa kwa kuwa tayari kuna vikundi vya kisasa dhidi ya vigezo vya awali.",
      "noResultFound": "HAKUNA MATOKEO YALIYOPATIKANA",
      "next": "Inayofuata",
      "cancel": "Ghairi",
      "selectAnimal": "Chagua Mnyama",
      "searchBy": "Tafuta Kwa",
      "breed": "Kuzaliana",
      "regDate": "Reg. ",
      "status": "Hali",
      "animalDetails": "Maelezo ya Wanyama",
      "add": "Ongeza",
      "update": "Sasisha",
      "dataForEPDs": " Data ya EPDs",
      "basicInformation": "Taarifa za Msingi",
      "birthWeightInformation": "Taarifa kuhusu Uzito wa Kuzaliwa",
      "weaningWeightInformation": "Habari za Uzito wa Kuachishwa",
      "yearlingWeightInformation": "Taarifa kuhusu uzito wa mwaka",
      "carcassWeightInformation": "Habari ya Uzito wa Mzoga",
      "delete": "Futa",
      "deleteEpdData": "Futa Data ya EPD",
      "areYouSureYouWantToDeleteEpdData": "Je, una uhakika unataka kufuta data ya EPD.",
      "internationalID": "Kitambulisho cha Kimataifa",
      "enterID": "Weka kitambulisho",
      "animalRegistration": "Usajili wa Wanyama",
      "location": "Mahali",
      "additionalIDMethod": "Njia ya Kitambulisho cha Ziada",
      "damID": "Kitambulisho cha bwawa",
      "sireID": "Kitambulisho cha Sire",
      "breederHerdCode": "Kanuni ya Kundi la Wafugaji",
      "birthYear": "mwaka wa kuzaliwa",
      "primaryBreed": "Uzazi wa Msingi",
      "breedComposition": "Muundo wa Kuzaliana",
      "secondaryBreed": "Ufugaji wa Sekondari",
      "seasonofBirth": "Msimu wa Kuzaliwa",
      "birthManagementCode": "Kanuni ya Usimamizi wa Kuzaliwa",
      "damAge": "Umri wa Bwawa",
      "years": "Miaka",
      "birthContemporaryCode": "Msimbo wa Kisasa wa Kuzaliwa",
      "accuracyWeight": "Uzito wa Usahihi",
      "note": "Kumbuka",
      "minimumRequiredFieldForBirthWeight": "Sehemu ya chini zaidi inayohitajika kwa EPD za Uzito wa Kuzaliwa",
      "birthYearGenderConceptionMethodBirthWeight": "Mwaka wa Kuzaliwa, Jinsia, Njia ya Kutunga mimba, Uzito wa Kuzaliwa",
      "weaningWeight": "Uzito wa kunyonya",
      "weaningDate": "Tarehe ya Kuachishwa",
      "weaningContemporaryGroupCode": "Msimbo wa Kikundi wa Kisasa wa Kuachisha ziwa",
      "creep": "Kuteleza",
      "managementPastureCode": "Kanuni ya Usimamizi/Malisho",
      "weaningSex": "Kuachisha Ngono",
      "minimumRequiredFieldForWeaningWeight": "Sehemu ya chini zaidi inayohitajika kwa EPD za Uzito wa Kuachisha",
      "weaningWeightManagementPastureCodeWeaningSexDateWeighed": "Uzito wa Kuachisha kunyonya , Usimamizi/Msimbo wa Malisho , Ngono ya Kuachisha kunyonya , Tarehe ya kupimwa",
      "yearlingWeight": "Uzito wa Mwaka",
      "yearlingHeight": "Urefu wa Mwaka",
      "yearlingDate": "Tarehe ya Mwaka",
      "yearlingContemporaryGroupCode": "Yearling Contemporary Group Code",
      "managementFeedingCode": "Kanuni ya Usimamizi/Kulisha",
      "yearlingSex": "Ngono ya Mwaka Mpya",
      "youWillNeedToFillOutFor": "Utahitaji kujaza sehemu zote ili kupata data ya EPD",
      "pleaseSelectHavestDateFirstToEnterInfo": "Tafadhali chagua 'Tarehe ya Mavuno' kwanza ili kuweka maelezo ya Eneo la Jicho la Ubavu, Unene wa Mafuta na Marbling.",
      "harvestDate": "Tarehe ya Mavuno",
      "dateOnFeed": "Tarehe ya Kulisha",
      "daysOnFeed": "Siku za Kulisha",
      "gradingDate": "Tarehe ya Kuweka Daraja",
      "carcassSex": "Ngono ya Mzoga",
      "carcassWeight": "Uzito wa Mzoga",
      "carcassContemporary": "Mzoga wa Kisasa",
      "damBreed": "Dam Breed",
      "ribEyeArea": "Eneo la Jicho la Mbavu",
      "ribEyeAreaContemporary": "Eneo la Jicho la Mbavu la Kisasa",
      "fatThickness": "Unene wa Mafuta",
      "fatThicknessContemporary": "Unene wa Unene wa Kisasa",
      "marbling": "Marbling",
      "marblingContemporary": "Marbling Contemporary",
      "yieldGradeContemporary": "Mavuno Daraja la kisasa",
      "animalsNotListedInContemporaryGroupsMsg": "Wanyama hawajaongezwa kwa vikundi vya kisasa kwa sababu ya kukosa habari. ",
      "listOfUngroupedAnimals": "Orodha ya Wanyama Wasiokuwa na Makundi",
      "submittingData": "Kuwasilisha Data",
      "resendToUser": "Tuma Upya Kwa Mtumiaji",
      "submittingAnimalsInGroupMsg": "Kuwasilisha wanyama wako katika vikundi. ",
      "pressingResetBtnMsg": "Kubonyeza kitufe cha \"Weka Upya\" kutaanzisha mchakato wa kuwapa wanyama upya kwa vikundi vyao vya kisasa.",
      "doYouWantToProceed": "Je, unataka kuendelea?",
      "systemMaintainanceModeMsg": "Kubonyeza kitufe cha \"Badilisha hadi Modi ya Utunzaji\" kutaanzisha mchakato na mfumo wako utaingia kwenye \"MAINTENANCE MODE\" ambapo EDPs zilizokokotwa katika KUWEKA UPYA hazitadumu kwa kila mnyama hadi KUWEKA UPYA (ambayo inaweza kuwa miezi 1-6). ",
      "errorFetchingContemporaryGrpMsg": "Hitilafu katika kuleta data ya kikundi cha kisasa",
      "deleteSuccess": "Futa Mafanikio",
      "deleteSuccessMsg": "Kikundi cha kisasa kimefutwa.",
      "deleteFailed": "Imeshindwa Kufuta",
      "deleteFailedMsg": "Hitilafu katika kufuta data ya kikundi cha kisasa",
      "deleteContemporaryGrpMsg": "Je, una uhakika unataka kufuta kikundi hiki cha kisasa?",
      "addBirthWeightData": "Ongeza Data ya Uzito wa Kuzaliwa",
      "addWeaningWeightData": "Ongeza Data ya Uzito wa Kuachishwa",
      "birthWeightContemporaryGroupCode": "Msimbo wa Kikundi wa Uzito wa Kuzaliwa",
      "dateWeighted": "Tarehe Iliyopimwa",
      "addYearlingWeightData": "Ongeza Data ya Uzito wa Mwaka",
      "addCarcassWeightData": "Ongeza Data ya Uzito wa Mzoga",
      "weaningOrYearlingContemporaryGroupCode": "Msimbo wa Kikundi wa Kikundi cha Uzito wa Kuachishwa au Kunyonyesha",
      "deleteContemporaryGroupMsg": "Je, una uhakika unataka kufuta kikundi cha kisasa?",
      "updateSuccessMsg": "Kikundi cha kisasa kimesasishwa.",
      "errorMsg": "Hitilafu fulani imetokea. ",
      "fetchErrorMsg": "Hitilafu katika kuleta sehemu zinazohitajika kwa sifa iliyochaguliwa.",
      "forMaintainanceMode": "Kwa Hali ya Matengenezo",
      "ancestorsWeightFactor": "Sababu ya Uzito wa mababu",
      "weightGivenToTheAncestorFactor": "Uzito unaotolewa kwa kipengele cha babu kinachohusiana na kipengele cha CG kwa hesabu ya EPD katika hali ya Matengenezo. ",
      "addEPDModelSettingsData": "Ongeza Data ya Mipangilio ya Muundo wa EPD",
      "minimumNumberOfAnimalsInContemporaryGroups": "Idadi ya Chini ya Wanyama katika Vikundi vya Kisasa",
      "enterNumberOfAnimals": "Weka Idadi ya Wanyama",
      "areYouSureYouWantToChangeEPDCalculation": "Je, una uhakika unataka kubadilisha sehemu zinazohitajika za hesabu za EPD?",
      "weightOfAnimalAtBirth": "Uzito wa Mnyama Wakati wa Kuzaliwa",
      "seasonIsAPeriodOfYear": "Msimu ni kipindi cha mwaka ambacho kinatofautishwa na hali maalum ya hali ya hewa.",
      "codeOfBirthWeightContemporaryGroup": "Msimbo wa Kikundi cha Kisasa cha Uzito wa Kuzaliwa",
      "weaningWeightOfCalf": "Kuachisha kunyonya Uzito wa Ndama",
      "dateAnimalWasWeaned": "Tarehe ambayo mnyama aliachishwa kunyonya",
      "genderOfWeaningAnimal": "Jinsia ya Mnyama anayeachishwa",
      "yearlingWeightOfCalf": "Uzito wa Ndama wa Mwaka",
      "dateAnimalWasWeighted": "Tarehe ambayo mnyama alipewa uzito",
      "yearledAnimalSex": "Jinsia ya mnyama ambaye alikuwa na mwaka",
      "dateOfAnimalKilledForMeat": "Tarehe ya mnyama aliyeuawa kwa ajili ya nyama",
      "addSuccessMsg": "Kikundi cha kisasa kimeongezwa",
      "traitH": "Tabia ya kuhesabu EPD.",
      "searchByValue": "Weka Nambari ya Usajili/Tatoo/Jina/Lebo"
    }
  }